import './assets/Wrapper.css';import './assets/base.css';var Wo = Object.defineProperty;
var Vo = (e, t, n) => t in e ? Wo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var P = (e, t, n) => (Vo(e, typeof t != "symbol" ? t + "" : t, n), n);
import { jsxs as Ut, Fragment as Wr, jsx as xe } from "react/jsx-runtime";
import $, { useMemo as rn, useState as M, useRef as re, useLayoutEffect as Wn, useEffect as I, useSyncExternalStore as Ko, isValidElement as pt, cloneElement as In, createContext as Vr, useContext as Kr, useCallback as Vn, useImperativeHandle as Jo, memo as Go } from "react";
import { API_LINK_QA as Jr, API_LINK_STAGING as Gr, API_LINK_LIVE as Xr } from "./core/constants.js";
import { Env as ht } from "./core/models/index.js";
import { AppId as Ce, ALL_ITEMS as ur } from "./core/models/PlatformNavigation.js";
import { g as Qr } from "./_commonjsHelpers-CT_km90n.js";
import { capitalize as dr, getEnding as An, equalInLC as Xo } from "./core/utils/string.js";
import { sanitizeWithProtocol as Xt, sanitize as Be } from "./core/utils/url.js";
import { c as on } from "./index-C7ezJk5b.js";
import "react-dom";
/* empty css                 */
import "react-router-dom";
import { cssX as ft, getRem as Qo } from "./core/utils/css.js";
var Yo = /* @__PURE__ */ ((e) => (e[e.FoodProfiles = 0] = "FoodProfiles", e[e.MacInstantCharts = 1] = "MacInstantCharts", e[e.ChainProfiles = 2] = "ChainProfiles", e[e.ReportProDocuments = 3] = "ReportProDocuments", e[e.MyDocsDocuments = 4] = "MyDocsDocuments", e))(Yo || {});
const _ = class _ {
  constructor(t) {
    P(this, 0, _.defaultData[
      0
      /* FoodProfiles */
    ]);
    P(this, 1, _.defaultData[
      1
      /* MacInstantCharts */
    ]);
    P(this, 2, _.defaultData[
      2
      /* ChainProfiles */
    ]);
    P(this, 3, _.defaultData[
      3
      /* ReportProDocuments */
    ]);
    P(this, 4, _.defaultData[
      4
      /* MyDocsDocuments */
    ]);
    P(this, "chainsInMenuCount", _.defaultData.chainsInMenuCount);
    P(this, "isPending", _.defaultData.isPending);
    t && (this.isPending = !1, t.apiModel && t.platformContextValue && this.fromApiModel(t.apiModel, t.platformContextValue));
  }
  setData(t) {
    Object.assign(this, t);
  }
  fromApiModel(t, n) {
    this.setData({
      ..._.defaultData,
      0: _.getFoodProfileResults(t, n),
      1: _.getMacInstantChartsResults(t, n),
      2: _.getChainProfilesResults(t, n),
      3: _.getReportProDocumentsResults(t, n),
      4: _.getMyDocsDocumentsResults(t, n),
      chainsInMenuCount: t.chainMenuItemsCount ?? _.defaultData.chainsInMenuCount,
      isPending: !1
    });
  }
  static getFoodProfileResults(t, n) {
    const { result: r } = t, o = r == null ? void 0 : r.find((a) => a.documentType === "FoodProfilesItem"), {
      userInfo: {
        snapUiUrl: i,
        snapFoodProfileUrl: s
      }
    } = n;
    return {
      ..._.defaultData[
        0
        /* FoodProfiles */
      ],
      items: ((o == null ? void 0 : o.items) || []).slice(0, 5).map((a) => {
        const l = (a.title ?? "").replace(/\(.*\)/, "").trim(), c = (a.title ?? "").replace(/^.*(\(.*\)).*$/, "$1");
        return {
          id: a.id,
          title: dr(l),
          subTitle: c,
          internalForApp: Ce.Snap,
          url: Xt(`${i}/${s}${encodeURIComponent(l)}`),
          path: `${s}${encodeURIComponent(l)}`
        };
      })
    };
  }
  static getMacInstantChartsResults(t, n) {
    const { result: r } = t, o = r == null ? void 0 : r.find((i) => i.documentType === "InstantChartsAndMacsItem");
    return {
      ..._.defaultData[
        1
        /* MacInstantCharts */
      ],
      items: ((o == null ? void 0 : o.items) || []).slice(0, 5).map((i) => ({
        id: i.id,
        title: dr(i.title ?? "").trim(),
        internalForApp: Ce.Snap,
        description: i.docType === 2 ? "Instant Chart" : "Menu Adoption Cycle",
        url: _.getSnapInternalUrl(
          i.docType === 2 ? _.getInstantChartsPath(i.id, n) : _.getMacPath(i.id, n),
          n
        ),
        path: i.docType === 2 ? _.getInstantChartsPath(i.id, n) : _.getMacPath(i.id, n)
      }))
    };
  }
  static getSnapInternalUrl(t, n) {
    const {
      userInfo: {
        snapUiUrl: r
      }
    } = n;
    return Xt(`${r}/${t}`, "https");
  }
  static getMacPath(t, n) {
    const {
      userInfo: {
        snapMacUrl: r
      }
    } = n;
    return Be(`/${r}${t}`);
  }
  static getInstantChartsPath(t, n) {
    const {
      userInfo: {
        snapInstantChartsUrl: r
      },
      globalSearch: {
        query: o
      }
    } = n;
    return Be(`/${r}${encodeURIComponent(o)}&id=${t}`);
  }
  static getChainProfilesResults(t, n) {
    const { result: r } = t, o = r == null ? void 0 : r.find((c) => c.documentType === "PlaceItem"), {
      userInfo: {
        snapChainProfileUrl: i,
        snapChainsUrl: s
      },
      globalSearch: {
        query: a
      }
    } = n, l = Be(`/${s}${a}`);
    return {
      ..._.defaultData[
        2
        /* ChainProfiles */
      ],
      moreResultsUrl: _.getSnapInternalUrl(l, n),
      moreResultsPath: l,
      items: ((o == null ? void 0 : o.items) || []).slice(0, 12).map((c) => {
        const u = Be(`/${i}${c.id}`);
        return {
          id: c.id,
          title: (c.title ?? "").trim(),
          internalForApp: Ce.Snap,
          description: _.getChainProfileDescription(c),
          url: _.getSnapInternalUrl(u, n),
          path: u
        };
      })
    };
  }
  static getChainProfileDescription(t) {
    return [
      t.segment,
      t.cuisine,
      `${t.numberOfUnits ?? 0} ${An("Unit", t.numberOfUnits ?? 0)}`
    ].filter((n) => !!n).join(" ◦ ");
  }
  static getReportProDocumentsResults(t, n) {
    const { result: r } = t, o = r == null ? void 0 : r.find((d) => d.documentType === "TrendspottingAndReportItem"), {
      userInfo: {
        reportProDetailsUrl: i,
        reportProMoreResultsUrl: s,
        products: a
      },
      globalSearch: {
        query: l
      }
    } = n, c = a[Ce.ReportPro].url, u = Be(`/${s}${l}`);
    return {
      ..._.defaultData[
        3
        /* ReportProDocuments */
      ],
      moreResultsPath: u,
      moreResultsUrl: Xt(`${c}/${u}`),
      items: ((o == null ? void 0 : o.items) || []).map((d) => {
        const g = Be(`/${i}/${d.id}`);
        return {
          id: d.id,
          title: (d.title ?? "").trim(),
          description: _.getReportProDocumentDescription(d),
          internalForApp: Ce.ReportPro,
          path: g,
          url: Xt(`${c}${g}`)
        };
      })
    };
  }
  static getReportProDocumentDescription(t) {
    return [
      `${t.pages ?? 0}  ${An("page", t.pages ?? 0)}`,
      t.dateTimeMonthAndYear
    ].filter((n) => !!n).join(" ◦ ");
  }
  static getMyDocsDocumentsResults(t, n) {
    const { result: r } = t, o = r == null ? void 0 : r.find((g) => g.documentType === "DocumentItem"), {
      userInfo: {
        snapMyDocsItemUrl: i,
        snapMyDocsProjectUrl: s,
        snapMoreDocsUrl: a,
        snapMyDocsUrl: l
      },
      globalSearch: {
        query: c
      }
    } = n, u = ((o == null ? void 0 : o.items) || []).some((g) => g.docType === 5), d = Be(`/${a}${c}`);
    return {
      ..._.defaultData[
        4
        /* MyDocsDocuments */
      ],
      moreResultsUrl: _.getSnapInternalUrl(
        u ? d : l,
        n
      ),
      moreResultsPath: u ? d : l,
      items: ((o == null ? void 0 : o.items) || []).slice(0, 5).map((g) => {
        const y = Be(
          g.docType === 5 ? `/${i}${g.id}` : `/${s}${g.instanceGuid}`
        );
        return {
          id: g.docType === 5 ? g.id : g.instanceGuid,
          title: (g.title ?? "").trim(),
          internalForApp: Ce.Snap,
          description: g.docType === 5 ? _.getMyDocsDocumentDescription(g) : _.getMyDocsProjectDescription(g),
          path: y,
          url: _.getSnapInternalUrl(y, n)
        };
      })
    };
  }
  static getMyDocsDocumentDescription(t) {
    return [
      t.projectName,
      (t.fileExtention ?? "").replace(".", ""),
      t.dateTimeMonthAndYear
    ].filter((n) => !!n).join(" ◦ ");
  }
  static getMyDocsProjectDescription(t) {
    return [
      `${t.documentsCount ?? 0} ${An("file", t.documentsCount ?? 0)}`,
      t.dateTimeMonthAndYear
    ].filter((n) => !!n).join(" ◦ ");
  }
};
P(_, "defaultData", {
  0: {
    id: 0,
    title: "FOOD PROFILES",
    internalForApp: Ce.Snap,
    items: []
  },
  1: {
    id: 1,
    internalForApp: Ce.Snap,
    title: "INSTANT CHARTS & MACs",
    items: []
  },
  2: {
    id: 2,
    internalForApp: Ce.Snap,
    title: "CHAINS",
    items: []
  },
  3: {
    id: 3,
    internalForApp: Ce.ReportPro,
    title: "REPORTS",
    items: []
  },
  4: {
    id: 4,
    internalForApp: Ce.Snap,
    title: "MY DOCS",
    items: []
  },
  chainsInMenuCount: 0,
  isPending: !0
});
let fr = _;
const E = class E {
  constructor(t) {
    P(this, "id", E.defaultData.id);
    P(this, "firstName", E.defaultData.firstName);
    P(this, "lastName", E.defaultData.lastName);
    P(this, "initials", E.defaultData.initials);
    P(this, "companyName", E.defaultData.companyName);
    P(this, "companyId", E.defaultData.companyId);
    P(this, "featureFlags", E.defaultData.featureFlags);
    P(this, "products", E.defaultData.products);
    P(this, "productsSections", E.defaultData.productsSections);
    P(this, "moreProducts", E.defaultData.moreProducts);
    P(this, "snapUiUrl", E.defaultData.snapUiUrl);
    P(this, "snapChainsUiUrl", E.defaultData.snapChainsUiUrl);
    P(this, "gtmId", E.defaultData.gtmId);
    P(this, "logOutLink", E.defaultData.logOutLink);
    P(this, "helpCenterUrl", E.defaultData.helpCenterUrl);
    P(this, "snapMyDocsUrl", E.defaultData.snapMyDocsUrl);
    P(this, "snapTeamsUrl", E.defaultData.snapTeamsUrl);
    P(this, "snapAdmin", E.defaultData.snapAdmin);
    P(this, "snapFoodProfileUrl", E.defaultData.snapFoodProfileUrl);
    P(this, "snapMacUrl", E.defaultData.snapMacUrl);
    P(this, "snapInstantChartsUrl", E.defaultData.snapInstantChartsUrl);
    P(this, "snapChainProfileUrl", E.defaultData.snapChainProfileUrl);
    P(this, "snapChainsUrl", E.defaultData.snapChainsUrl);
    P(this, "snapChainsInMenuUrl", E.defaultData.snapChainsInMenuUrl);
    P(this, "snapMoreDocsUrl", E.defaultData.snapMoreDocsUrl);
    P(this, "snapMyDocsItemUrl", E.defaultData.snapMyDocsItemUrl);
    P(this, "snapMyDocsProjectUrl", E.defaultData.snapMyDocsProjectUrl);
    P(this, "snapSearchResultsUrl", E.defaultData.snapSearchResultsUrl);
    P(this, "reportProDetailsUrl", E.defaultData.reportProDetailsUrl);
    P(this, "reportProMoreResultsUrl", E.defaultData.reportProMoreResultsUrl);
    P(this, "injectedCss", E.defaultData.injectedCss);
    t && t.apiModel && this.fromApiModel(t.apiModel);
  }
  setData(t) {
    Object.assign(this, t);
  }
  static getRestProducts(t) {
    const {
      navigationItems: n
    } = t, r = E.getAppIds(t);
    return (n || []).filter((o) => !r.includes(o.appId)).map((o) => ({
      url: o.url ?? "",
      name: o.title ?? ""
    }));
  }
  static getProductsLogos(t, n) {
    const {
      productsLogoDataJson: r = "{}",
      productsLogoGsDataJson: o = "{}",
      productsLogoTextDataJson: i = "{}",
      productsLogoTextLightDataJson: s = "{}"
    } = n.parameterStoreValues, a = JSON.parse(r)[t], l = JSON.parse(o)[t], c = JSON.parse(i)[t], u = JSON.parse(s)[t];
    return {
      logoSrc: a,
      logoGsSrc: l,
      logoTextSrc: c,
      logoTextLightSrc: u
    };
  }
  static mapNavigationItemToProductInfo(t, n) {
    const {
      navigationItems: r,
      parameterStoreValues: o
    } = n, {
      productsConfigJson: i = "{}"
    } = o, s = ur[t] ?? {}, a = JSON.parse(i)[t], l = (r || []).find((u) => u.appId === t);
    let c = (a == null ? void 0 : a.isDisabledByDefault) ?? !1;
    return l != null && l.hasOwnProperty("hasAccess") && (c = !l.hasAccess), {
      ...s,
      name: (a == null ? void 0 : a.name) ?? "",
      isDisabled: c,
      description: (a == null ? void 0 : a.description) ?? "",
      gtmToolName: (a == null ? void 0 : a.gtmToolName) ?? "",
      url: (l == null ? void 0 : l.url) ?? "",
      ...E.getProductsLogos(t, n)
    };
  }
  static getAppIds(t) {
    const {
      parameterStoreValues: n
    } = t, {
      productsConfigJson: r = "{}"
    } = n;
    return Object.keys(JSON.parse(r));
  }
  static getProducts(t) {
    return E.getAppIds(t).reduce((r, o) => ({
      ...r,
      [o]: E.mapNavigationItemToProductInfo(o, t)
    }), {});
  }
  static getProductsSections(t) {
    const {
      parameterStoreValues: n
    } = t, {
      productsSectionsDataJson: r
    } = n;
    return r ? JSON.parse(r) : E.defaultData.productsSections;
  }
  static getFeatureFlags(t) {
    return t.featureFlags ? t.featureFlags.filter((n) => n.isOn).map((n) => n.name) : E.defaultData.featureFlags;
  }
  static getSnapAdmin(t) {
    const { headerUserActionsMenuItems: n } = t, r = n == null ? void 0 : n.find((o) => o.title === "ADMIN");
    return r ? {
      url: r.url ?? ""
    } : null;
  }
  fromApiModel(t) {
    const { parameterStoreValues: n } = t, {
      gtmId: r,
      snapUiUrl: o,
      snapChainsUiUrl: i,
      logOutLink: s,
      helpCenterUrl: a,
      snapMyDocsUrl: l,
      snapTeamsUrl: c,
      snapFoodProfileUrl: u,
      snapMacUrl: d,
      snapInstantChartsUrl: g,
      snapChainProfileUrl: y,
      snapChainsUrl: f,
      snapChainsInMenuUrl: m,
      snapMoreDocsUrl: h,
      snapMyDocsItemUrl: v,
      snapMyDocsProjectUrl: b,
      snapSearchResultsUrl: w,
      reportProDetailsUrl: S,
      reportProMoreResultsUrl: A,
      injectedCss: U
    } = n;
    this.setData({
      id: t.id ?? E.defaultData.id,
      firstName: t.firstName ?? E.defaultData.firstName,
      lastName: t.lastName ?? E.defaultData.lastName,
      initials: t.initials ?? E.defaultData.initials,
      companyName: t.companyName ?? E.defaultData.companyName,
      companyId: t.companyId ?? E.defaultData.companyId,
      featureFlags: E.getFeatureFlags(t),
      products: E.getProducts(t),
      productsSections: E.getProductsSections(t),
      moreProducts: E.getRestProducts(t),
      gtmId: r ?? E.defaultData.gtmId,
      snapUiUrl: o ?? E.defaultData.snapUiUrl,
      logOutLink: s ?? E.defaultData.logOutLink,
      helpCenterUrl: a ?? E.defaultData.helpCenterUrl,
      snapChainsUiUrl: i ?? E.defaultData.snapChainsUiUrl,
      snapMyDocsUrl: l ?? E.defaultData.snapMyDocsUrl,
      snapTeamsUrl: c ?? E.defaultData.snapTeamsUrl,
      snapAdmin: E.getSnapAdmin(t) ?? E.defaultData.snapAdmin,
      snapFoodProfileUrl: u ?? E.defaultData.snapFoodProfileUrl,
      snapMacUrl: d ?? E.defaultData.snapMacUrl,
      snapInstantChartsUrl: g ?? E.defaultData.snapInstantChartsUrl,
      snapChainProfileUrl: y ?? E.defaultData.snapChainProfileUrl,
      snapChainsUrl: f ?? E.defaultData.snapChainsUrl,
      snapChainsInMenuUrl: m ?? E.defaultData.snapChainsInMenuUrl,
      snapMoreDocsUrl: h ?? E.defaultData.snapMoreDocsUrl,
      snapMyDocsItemUrl: v ?? E.defaultData.snapMyDocsItemUrl,
      snapMyDocsProjectUrl: b ?? E.defaultData.snapMyDocsProjectUrl,
      snapSearchResultsUrl: w ?? E.defaultData.snapSearchResultsUrl,
      reportProDetailsUrl: S ?? E.defaultData.reportProDetailsUrl,
      reportProMoreResultsUrl: A ?? E.defaultData.reportProMoreResultsUrl,
      injectedCss: U ?? E.defaultData.injectedCss
    });
  }
};
P(E, "defaultData", {
  id: "",
  firstName: "",
  lastName: "",
  initials: "",
  companyName: "",
  companyId: 0,
  featureFlags: [],
  products: ur,
  productsSections: [],
  moreProducts: [],
  gtmId: "GTM-P7XQNKJ",
  snapUiUrl: "https://snap.datassential.com",
  snapChainsUiUrl: "https://snap.datassential.com/fireflyChains",
  logOutLink: "https://apps.datassential.com/snap/account/signOut",
  helpCenterUrl: "https://help.datassential.com",
  snapAdmin: null,
  snapMyDocsUrl: "/myDocuments",
  snapTeamsUrl: "/groups",
  snapFoodProfileUrl: "/food?q=",
  snapMacUrl: "/view-document?doctype=3&id=",
  snapInstantChartsUrl: "/instantCharts?q=",
  snapChainProfileUrl: "/chainDetails?id=",
  snapChainsUrl: "/places?q=",
  snapChainsInMenuUrl: "/places?tabIndex=2&q=",
  snapMoreDocsUrl: "/documents?q=",
  snapMyDocsItemUrl: "/view-document?doctype=5&id=",
  snapMyDocsProjectUrl: "/project?id=",
  snapSearchResultsUrl: "/search?q=",
  reportProDetailsUrl: "/details/",
  reportProMoreResultsUrl: "?q=",
  injectedCss: ""
});
let Qe = E;
function Zo(e) {
  const { userInfo: { featureFlags: t } } = Wt();
  return rn(
    () => t.some((n) => Xo(e.trim(), n.trim())),
    [t]
  );
}
var Kn = {};
Object.defineProperty(Kn, "__esModule", {
  value: !0
});
var es = function(t) {
  console.warn("[react-gtm]", t);
};
Kn.default = es;
var ts = Kn, ns = rs(ts);
function rs(e) {
  return e && e.__esModule ? e : { default: e };
}
var os = {
  tags: function(t) {
    var n = t.id, r = t.events, o = t.dataLayer, i = t.dataLayerName, s = t.preview, a = t.auth, l = "&gtm_auth=" + a, c = "&gtm_preview=" + s;
    n || (0, ns.default)("GTM Id is required");
    var u = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=` + n + l + c + `&gtm_cookies_win=x"
        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>`, d = `
      (function(w,d,s,l,i){w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js', ` + JSON.stringify(r).slice(1, -1) + `});
        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'` + l + c + `&gtm_cookies_win=x';
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','` + i + "','" + n + "');", g = this.dataLayer(o, i);
    return {
      iframe: u,
      script: d,
      dataLayerVar: g
    };
  },
  dataLayer: function(t, n) {
    return `
      window.` + n + " = window." + n + ` || [];
      window.` + n + ".push(" + JSON.stringify(t) + ")";
  }
}, ss = os, is = ss, pr = as(is);
function as(e) {
  return e && e.__esModule ? e : { default: e };
}
var ls = {
  dataScript: function(t) {
    var n = document.createElement("script");
    return n.innerHTML = t, n;
  },
  gtm: function(t) {
    var n = pr.default.tags(t), r = function() {
      var a = document.createElement("noscript");
      return a.innerHTML = n.iframe, a;
    }, o = function() {
      var a = document.createElement("script");
      return a.innerHTML = n.script, a;
    }, i = this.dataScript(n.dataLayerVar);
    return {
      noScript: r,
      script: o,
      dataScript: i
    };
  },
  initialize: function(t) {
    var n = t.gtmId, r = t.events, o = r === void 0 ? {} : r, i = t.dataLayer, s = t.dataLayerName, a = s === void 0 ? "dataLayer" : s, l = t.auth, c = l === void 0 ? "" : l, u = t.preview, d = u === void 0 ? "" : u, g = this.gtm({
      id: n,
      events: o,
      dataLayer: i || void 0,
      dataLayerName: a,
      auth: c,
      preview: d
    });
    i && document.head.appendChild(g.dataScript), document.head.insertBefore(g.script(), document.head.childNodes[0]), document.body.insertBefore(g.noScript(), document.body.childNodes[0]);
  },
  dataLayer: function(t) {
    var n = t.dataLayer, r = t.dataLayerName, o = r === void 0 ? "dataLayer" : r;
    if (window[o])
      return window[o].push(n);
    var i = pr.default.dataLayer(n, o), s = this.dataScript(i);
    document.head.insertBefore(s, document.head.childNodes[0]);
  }
}, cs = ls, us = cs, ds = fs(us);
function fs(e) {
  return e && e.__esModule ? e : { default: e };
}
var ps = ds.default;
const Cl = /* @__PURE__ */ Qr(ps);
var ms = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++)
    n.push(e.getRangeAt(r));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(o) {
      e.addRange(o);
    }), t && t.focus();
  };
}, hs = ms, mr = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, gs = "Copy to clipboard: #{key}, Enter";
function ys(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function ws(e, t) {
  var n, r, o, i, s, a, l = !1;
  t || (t = {}), n = t.debug || !1;
  try {
    o = hs(), i = document.createRange(), s = document.getSelection(), a = document.createElement("span"), a.textContent = e, a.ariaHidden = "true", a.style.all = "unset", a.style.position = "fixed", a.style.top = 0, a.style.clip = "rect(0, 0, 0, 0)", a.style.whiteSpace = "pre", a.style.webkitUserSelect = "text", a.style.MozUserSelect = "text", a.style.msUserSelect = "text", a.style.userSelect = "text", a.addEventListener("copy", function(u) {
      if (u.stopPropagation(), t.format)
        if (u.preventDefault(), typeof u.clipboardData > "u") {
          n && console.warn("unable to use e.clipboardData"), n && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var d = mr[t.format] || mr.default;
          window.clipboardData.setData(d, e);
        } else
          u.clipboardData.clearData(), u.clipboardData.setData(t.format, e);
      t.onCopy && (u.preventDefault(), t.onCopy(u.clipboardData));
    }), document.body.appendChild(a), i.selectNodeContents(a), s.addRange(i);
    var c = document.execCommand("copy");
    if (!c)
      throw new Error("copy command was unsuccessful");
    l = !0;
  } catch (u) {
    n && console.error("unable to copy using execCommand: ", u), n && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), l = !0;
    } catch (d) {
      n && console.error("unable to copy using clipboardData: ", d), n && console.error("falling back to prompt"), r = ys("message" in t ? t.message : gs), window.prompt(r, e);
    }
  } finally {
    s && (typeof s.removeRange == "function" ? s.removeRange(i) : s.removeAllRanges()), a && document.body.removeChild(a), o();
  }
  return l;
}
var vs = ws;
const bs = /* @__PURE__ */ Qr(vs);
function Yr(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = Yr(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function qe() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = Yr(e)) && (r && (r += " "), r += t);
  return r;
}
const kt = (e) => typeof e == "number" && !isNaN(e), Ye = (e) => typeof e == "string", be = (e) => typeof e == "function", en = (e) => Ye(e) || be(e) ? e : null, Nn = (e) => pt(e) || Ye(e) || be(e) || kt(e);
function Es(e, t, n) {
  n === void 0 && (n = 300);
  const { scrollHeight: r, style: o } = e;
  requestAnimationFrame(() => {
    o.minHeight = "initial", o.height = r + "px", o.transition = `all ${n}ms`, requestAnimationFrame(() => {
      o.height = "0", o.padding = "0", o.margin = "0", setTimeout(t, n);
    });
  });
}
function fn(e) {
  let { enter: t, exit: n, appendPosition: r = !1, collapse: o = !0, collapseDuration: i = 300 } = e;
  return function(s) {
    let { children: a, position: l, preventExitTransition: c, done: u, nodeRef: d, isIn: g, playToast: y } = s;
    const f = r ? `${t}--${l}` : t, m = r ? `${n}--${l}` : n, h = re(0);
    return Wn(() => {
      const v = d.current, b = f.split(" "), w = (S) => {
        S.target === d.current && (y(), v.removeEventListener("animationend", w), v.removeEventListener("animationcancel", w), h.current === 0 && S.type !== "animationcancel" && v.classList.remove(...b));
      };
      v.classList.add(...b), v.addEventListener("animationend", w), v.addEventListener("animationcancel", w);
    }, []), I(() => {
      const v = d.current, b = () => {
        v.removeEventListener("animationend", b), o ? Es(v, u, i) : u();
      };
      g || (c ? b() : (h.current = 1, v.className += ` ${m}`, v.addEventListener("animationend", b)));
    }, [g]), $.createElement($.Fragment, null, a);
  };
}
function hr(e, t) {
  return e != null ? { content: e.content, containerId: e.props.containerId, id: e.props.toastId, theme: e.props.theme, type: e.props.type, data: e.props.data || {}, isLoading: e.props.isLoading, icon: e.props.icon, status: t } : {};
}
const de = /* @__PURE__ */ new Map();
let Mt = [];
const Un = /* @__PURE__ */ new Set(), Ss = (e) => Un.forEach((t) => t(e)), Zr = () => de.size > 0;
function eo(e, t) {
  var n;
  if (t)
    return !((n = de.get(t)) == null || !n.isToastActive(e));
  let r = !1;
  return de.forEach((o) => {
    o.isToastActive(e) && (r = !0);
  }), r;
}
function to(e, t) {
  Nn(e) && (Zr() || Mt.push({ content: e, options: t }), de.forEach((n) => {
    n.buildToast(e, t);
  }));
}
function gr(e, t) {
  de.forEach((n) => {
    t != null && t != null && t.containerId ? (t == null ? void 0 : t.containerId) === n.id && n.toggle(e, t == null ? void 0 : t.id) : n.toggle(e, t == null ? void 0 : t.id);
  });
}
function Ts(e) {
  const { subscribe: t, getSnapshot: n, setProps: r } = re(function(i) {
    const s = i.containerId || 1;
    return { subscribe(a) {
      const l = /* @__PURE__ */ function(u, d, g) {
        let y = 1, f = 0, m = [], h = [], v = [], b = d;
        const w = /* @__PURE__ */ new Map(), S = /* @__PURE__ */ new Set(), A = () => {
          v = Array.from(w.values()), S.forEach((C) => C());
        }, U = (C) => {
          h = C == null ? [] : h.filter((N) => N !== C), A();
        }, R = (C) => {
          const { toastId: N, onOpen: K, updateId: Y, children: H } = C.props, oe = Y == null;
          C.staleId && w.delete(C.staleId), w.set(N, C), h = [...h, C.props.toastId].filter((F) => F !== C.staleId), A(), g(hr(C, oe ? "added" : "updated")), oe && be(K) && K(pt(H) && H.props);
        };
        return { id: u, props: b, observe: (C) => (S.add(C), () => S.delete(C)), toggle: (C, N) => {
          w.forEach((K) => {
            N != null && N !== K.props.toastId || be(K.toggle) && K.toggle(C);
          });
        }, removeToast: U, toasts: w, clearQueue: () => {
          f -= m.length, m = [];
        }, buildToast: (C, N) => {
          if (((ce) => {
            let { containerId: se, toastId: ie, updateId: me } = ce;
            const ye = se ? se !== u : u !== 1, Q = w.has(ie) && me == null;
            return ye || Q;
          })(N))
            return;
          const { toastId: K, updateId: Y, data: H, staleId: oe, delay: F } = N, J = () => {
            U(K);
          }, G = Y == null;
          G && f++;
          const j = { ...b, style: b.toastStyle, key: y++, ...Object.fromEntries(Object.entries(N).filter((ce) => {
            let [se, ie] = ce;
            return ie != null;
          })), toastId: K, updateId: Y, data: H, closeToast: J, isIn: !1, className: en(N.className || b.toastClassName), bodyClassName: en(N.bodyClassName || b.bodyClassName), progressClassName: en(N.progressClassName || b.progressClassName), autoClose: !N.isLoading && (ee = N.autoClose, fe = b.autoClose, ee === !1 || kt(ee) && ee > 0 ? ee : fe), deleteToast() {
            const ce = w.get(K), { onClose: se, children: ie } = ce.props;
            be(se) && se(pt(ie) && ie.props), g(hr(ce, "removed")), w.delete(K), f--, f < 0 && (f = 0), m.length > 0 ? R(m.shift()) : A();
          } };
          var ee, fe;
          j.closeButton = b.closeButton, N.closeButton === !1 || Nn(N.closeButton) ? j.closeButton = N.closeButton : N.closeButton === !0 && (j.closeButton = !Nn(b.closeButton) || b.closeButton);
          let B = C;
          pt(C) && !Ye(C.type) ? B = In(C, { closeToast: J, toastProps: j, data: H }) : be(C) && (B = C({ closeToast: J, toastProps: j, data: H }));
          const pe = { content: B, props: j, staleId: oe };
          b.limit && b.limit > 0 && f > b.limit && G ? m.push(pe) : kt(F) ? setTimeout(() => {
            R(pe);
          }, F) : R(pe);
        }, setProps(C) {
          b = C;
        }, setToggle: (C, N) => {
          w.get(C).toggle = N;
        }, isToastActive: (C) => h.some((N) => N === C), getSnapshot: () => b.newestOnTop ? v.reverse() : v };
      }(s, i, Ss);
      de.set(s, l);
      const c = l.observe(a);
      return Mt.forEach((u) => to(u.content, u.options)), Mt = [], () => {
        c(), de.delete(s);
      };
    }, setProps(a) {
      var l;
      (l = de.get(s)) == null || l.setProps(a);
    }, getSnapshot() {
      var a;
      return (a = de.get(s)) == null ? void 0 : a.getSnapshot();
    } };
  }(e)).current;
  r(e);
  const o = Ko(t, n, n);
  return { getToastToRender: function(i) {
    if (!o)
      return [];
    const s = /* @__PURE__ */ new Map();
    return o.forEach((a) => {
      const { position: l } = a.props;
      s.has(l) || s.set(l, []), s.get(l).push(a);
    }), Array.from(s, (a) => i(a[0], a[1]));
  }, isToastActive: eo, count: o == null ? void 0 : o.length };
}
function As(e) {
  const [t, n] = M(!1), [r, o] = M(!1), i = re(null), s = re({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, didMove: !1 }).current, { autoClose: a, pauseOnHover: l, closeToast: c, onClick: u, closeOnClick: d } = e;
  var g, y;
  function f() {
    n(!0);
  }
  function m() {
    n(!1);
  }
  function h(w) {
    const S = i.current;
    s.canDrag && S && (s.didMove = !0, t && m(), s.delta = e.draggableDirection === "x" ? w.clientX - s.start : w.clientY - s.start, s.start !== w.clientX && (s.canCloseOnClick = !1), S.style.transform = `translate3d(${e.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`},0)`, S.style.opacity = "" + (1 - Math.abs(s.delta / s.removalDistance)));
  }
  function v() {
    document.removeEventListener("pointermove", h), document.removeEventListener("pointerup", v);
    const w = i.current;
    if (s.canDrag && s.didMove && w) {
      if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance)
        return o(!0), e.closeToast(), void e.collapseAll();
      w.style.transition = "transform 0.2s, opacity 0.2s", w.style.removeProperty("transform"), w.style.removeProperty("opacity");
    }
  }
  (y = de.get((g = { id: e.toastId, containerId: e.containerId, fn: n }).containerId || 1)) == null || y.setToggle(g.id, g.fn), I(() => {
    if (e.pauseOnFocusLoss)
      return document.hasFocus() || m(), window.addEventListener("focus", f), window.addEventListener("blur", m), () => {
        window.removeEventListener("focus", f), window.removeEventListener("blur", m);
      };
  }, [e.pauseOnFocusLoss]);
  const b = { onPointerDown: function(w) {
    if (e.draggable === !0 || e.draggable === w.pointerType) {
      s.didMove = !1, document.addEventListener("pointermove", h), document.addEventListener("pointerup", v);
      const S = i.current;
      s.canCloseOnClick = !0, s.canDrag = !0, S.style.transition = "none", e.draggableDirection === "x" ? (s.start = w.clientX, s.removalDistance = S.offsetWidth * (e.draggablePercent / 100)) : (s.start = w.clientY, s.removalDistance = S.offsetHeight * (e.draggablePercent === 80 ? 1.5 * e.draggablePercent : e.draggablePercent) / 100);
    }
  }, onPointerUp: function(w) {
    const { top: S, bottom: A, left: U, right: R } = i.current.getBoundingClientRect();
    w.nativeEvent.type !== "touchend" && e.pauseOnHover && w.clientX >= U && w.clientX <= R && w.clientY >= S && w.clientY <= A ? m() : f();
  } };
  return a && l && (b.onMouseEnter = m, e.stacked || (b.onMouseLeave = f)), d && (b.onClick = (w) => {
    u && u(w), s.canCloseOnClick && c();
  }), { playToast: f, pauseToast: m, isRunning: t, preventExitTransition: r, toastRef: i, eventHandlers: b };
}
function Rs(e) {
  let { delay: t, isRunning: n, closeToast: r, type: o = "default", hide: i, className: s, style: a, controlledProgress: l, progress: c, rtl: u, isIn: d, theme: g } = e;
  const y = i || l && c === 0, f = { ...a, animationDuration: `${t}ms`, animationPlayState: n ? "running" : "paused" };
  l && (f.transform = `scaleX(${c})`);
  const m = qe("Toastify__progress-bar", l ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${o}`, { "Toastify__progress-bar--rtl": u }), h = be(s) ? s({ rtl: u, type: o, defaultClassName: m }) : qe(m, s), v = { [l && c >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: l && c < 1 ? null : () => {
    d && r();
  } };
  return $.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": y }, $.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${o}` }), $.createElement("div", { role: "progressbar", "aria-hidden": y ? "true" : "false", "aria-label": "notification timer", className: h, style: f, ...v }));
}
let Cs = 1;
const no = () => "" + Cs++;
function Ds(e) {
  return e && (Ye(e.toastId) || kt(e.toastId)) ? e.toastId : no();
}
function _t(e, t) {
  return to(e, t), t.toastId;
}
function sn(e, t) {
  return { ...t, type: t && t.type || e, toastId: Ds(t) };
}
function Qt(e) {
  return (t, n) => _t(t, sn(e, n));
}
function q(e, t) {
  return _t(e, sn("default", t));
}
q.loading = (e, t) => _t(e, sn("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...t })), q.promise = function(e, t, n) {
  let r, { pending: o, error: i, success: s } = t;
  o && (r = Ye(o) ? q.loading(o, n) : q.loading(o.render, { ...n, ...o }));
  const a = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, l = (u, d, g) => {
    if (d == null)
      return void q.dismiss(r);
    const y = { type: u, ...a, ...n, data: g }, f = Ye(d) ? { render: d } : d;
    return r ? q.update(r, { ...y, ...f }) : q(f.render, { ...y, ...f }), g;
  }, c = be(e) ? e() : e;
  return c.then((u) => l("success", s, u)).catch((u) => l("error", i, u)), c;
}, q.success = Qt("success"), q.info = Qt("info"), q.error = Qt("error"), q.warning = Qt("warning"), q.warn = q.warning, q.dark = (e, t) => _t(e, sn("default", { theme: "dark", ...t })), q.dismiss = function(e) {
  (function(t) {
    var n;
    if (Zr()) {
      if (t == null || Ye(n = t) || kt(n))
        de.forEach((r) => {
          r.removeToast(t);
        });
      else if (t && ("containerId" in t || "id" in t)) {
        const r = de.get(t.containerId);
        r ? r.removeToast(t.id) : de.forEach((o) => {
          o.removeToast(t.id);
        });
      }
    } else
      Mt = Mt.filter((r) => t != null && r.options.toastId !== t);
  })(e);
}, q.clearWaitingQueue = function(e) {
  e === void 0 && (e = {}), de.forEach((t) => {
    !t.props.limit || e.containerId && t.id !== e.containerId || t.clearQueue();
  });
}, q.isActive = eo, q.update = function(e, t) {
  t === void 0 && (t = {});
  const n = ((r, o) => {
    var i;
    let { containerId: s } = o;
    return (i = de.get(s || 1)) == null ? void 0 : i.toasts.get(r);
  })(e, t);
  if (n) {
    const { props: r, content: o } = n, i = { delay: 100, ...r, ...t, toastId: t.toastId || e, updateId: no() };
    i.toastId !== e && (i.staleId = e);
    const s = i.render || o;
    delete i.render, _t(s, i);
  }
}, q.done = (e) => {
  q.update(e, { progress: 1 });
}, q.onChange = function(e) {
  return Un.add(e), () => {
    Un.delete(e);
  };
}, q.play = (e) => gr(!0, e), q.pause = (e) => gr(!1, e);
const xs = typeof window < "u" ? Wn : I, Yt = (e) => {
  let { theme: t, type: n, isLoading: r, ...o } = e;
  return $.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${n})`, ...o });
}, Rn = { info: function(e) {
  return $.createElement(Yt, { ...e }, $.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(e) {
  return $.createElement(Yt, { ...e }, $.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(e) {
  return $.createElement(Yt, { ...e }, $.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(e) {
  return $.createElement(Yt, { ...e }, $.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return $.createElement("div", { className: "Toastify__spinner" });
} }, Os = (e) => {
  const { isRunning: t, preventExitTransition: n, toastRef: r, eventHandlers: o, playToast: i } = As(e), { closeButton: s, children: a, autoClose: l, onClick: c, type: u, hideProgressBar: d, closeToast: g, transition: y, position: f, className: m, style: h, bodyClassName: v, bodyStyle: b, progressClassName: w, progressStyle: S, updateId: A, role: U, progress: R, rtl: C, toastId: N, deleteToast: K, isIn: Y, isLoading: H, closeOnClick: oe, theme: F } = e, J = qe("Toastify__toast", `Toastify__toast-theme--${F}`, `Toastify__toast--${u}`, { "Toastify__toast--rtl": C }, { "Toastify__toast--close-on-click": oe }), G = be(m) ? m({ rtl: C, position: f, type: u, defaultClassName: J }) : qe(J, m), j = function(pe) {
    let { theme: ce, type: se, isLoading: ie, icon: me } = pe, ye = null;
    const Q = { theme: ce, type: se };
    return me === !1 || (be(me) ? ye = me({ ...Q, isLoading: ie }) : pt(me) ? ye = In(me, Q) : ie ? ye = Rn.spinner() : ((Me) => Me in Rn)(se) && (ye = Rn[se](Q))), ye;
  }(e), ee = !!R || !l, fe = { closeToast: g, type: u, theme: F };
  let B = null;
  return s === !1 || (B = be(s) ? s(fe) : pt(s) ? In(s, fe) : function(pe) {
    let { closeToast: ce, theme: se, ariaLabel: ie = "close" } = pe;
    return $.createElement("button", { className: `Toastify__close-button Toastify__close-button--${se}`, type: "button", onClick: (me) => {
      me.stopPropagation(), ce(me);
    }, "aria-label": ie }, $.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, $.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
  }(fe)), $.createElement(y, { isIn: Y, done: K, position: f, preventExitTransition: n, nodeRef: r, playToast: i }, $.createElement("div", { id: N, onClick: c, "data-in": Y, className: G, ...o, style: h, ref: r }, $.createElement("div", { ...Y && { role: U }, className: be(v) ? v({ type: u }) : qe("Toastify__toast-body", v), style: b }, j != null && $.createElement("div", { className: qe("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !H }) }, j), $.createElement("div", null, a)), B, $.createElement(Rs, { ...A && !ee ? { key: `pb-${A}` } : {}, rtl: C, theme: F, delay: l, isRunning: t, isIn: Y, closeToast: g, hide: d, type: u, style: S, className: w, controlledProgress: ee, progress: R || 0 })));
}, pn = function(e, t) {
  return t === void 0 && (t = !1), { enter: `Toastify--animate Toastify__${e}-enter`, exit: `Toastify--animate Toastify__${e}-exit`, appendPosition: t };
}, Ls = fn(pn("bounce", !0)), Ps = fn(pn("slide", !0));
fn(pn("zoom"));
fn(pn("flip"));
const Is = { position: "top-right", transition: Ls, autoClose: 5e3, closeButton: !0, pauseOnHover: !0, pauseOnFocusLoss: !0, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
function Ns(e) {
  let t = { ...Is, ...e };
  const n = e.stacked, [r, o] = M(!0), i = re(null), { getToastToRender: s, isToastActive: a, count: l } = Ts(t), { className: c, style: u, rtl: d, containerId: g } = t;
  function y(m) {
    const h = qe("Toastify__toast-container", `Toastify__toast-container--${m}`, { "Toastify__toast-container--rtl": d });
    return be(c) ? c({ position: m, rtl: d, defaultClassName: h }) : qe(h, en(c));
  }
  function f() {
    n && (o(!0), q.play());
  }
  return xs(() => {
    if (n) {
      var m;
      const h = i.current.querySelectorAll('[data-in="true"]'), v = 12, b = (m = t.position) == null ? void 0 : m.includes("top");
      let w = 0, S = 0;
      Array.from(h).reverse().forEach((A, U) => {
        const R = A;
        R.classList.add("Toastify__toast--stacked"), U > 0 && (R.dataset.collapsed = `${r}`), R.dataset.pos || (R.dataset.pos = b ? "top" : "bot");
        const C = w * (r ? 0.2 : 1) + (r ? 0 : v * U);
        R.style.setProperty("--y", `${b ? C : -1 * C}px`), R.style.setProperty("--g", `${v}`), R.style.setProperty("--s", "" + (1 - (r ? S : 0))), w += R.offsetHeight, S += 0.025;
      });
    }
  }, [r, l, n]), $.createElement("div", { ref: i, className: "Toastify", id: g, onMouseEnter: () => {
    n && (o(!1), q.pause());
  }, onMouseLeave: f }, s((m, h) => {
    const v = h.length ? { ...u } : { ...u, pointerEvents: "none" };
    return $.createElement("div", { className: y(m), style: v, key: `container-${m}` }, h.map((b) => {
      let { content: w, props: S } = b;
      return $.createElement(Os, { ...S, stacked: n, collapseAll: f, isIn: a(S.toastId, S.containerId), style: S.style, key: `toast-${S.key}` }, w);
    }));
  }));
}
var Us = /* @__PURE__ */ ((e) => (e[e.None = 0] = "None", e[e.TestId = 1] = "TestId", e[e.Interactive = 2] = "Interactive", e))(Us || {});
function ro(e) {
  const t = e.parentNode.closest("[data-testid]");
  let n = [];
  return t !== null && (n = [...ro(t)]), e.hasAttribute("data-testid") && (n = [...n, e.getAttribute("data-testid")]), n;
}
const yr = {
  0: "",
  1: "DevTools Test ID Mode",
  2: "DevTools Interactive Mode"
}, _s = {
  0: "",
  1: "perform [shift + alt + click] to copy test ID",
  2: ""
}, ks = {
  0: 1,
  1: 2,
  2: 0
  /* None */
}, Ms = () => {
  const [e, t] = M(
    0
    /* None */
  ), [n, r] = M([]), o = rn(
    () => yr[e] || "",
    [e]
  ), i = rn(
    () => _s[e] || "",
    [e]
  );
  return I(() => {
    const s = (l) => {
      l.key === "Enter" && l.altKey && l.shiftKey && (t(ks[e]), yr[
        0
        /* None */
      ] = "DevTools is OFF");
    }, a = (l) => {
      var c;
      if (e === 1) {
        l.stopImmediatePropagation();
        const u = (c = l.target) == null ? void 0 : c.closest("[data-testid]"), d = [];
        if (u) {
          d.push(`Test ID: ${u.getAttribute("data-testid")}`);
          const g = ro(u.parentNode);
          let y = u.nodeName.toLowerCase();
          const f = Array.from(u.classList).join(".");
          f && (y += `.${f}`), d.push(`Node: ${y}`), g.forEach((m) => d.push(`Parent Test ID: ${m}`));
        }
        r(d);
      } else
        r([]);
    };
    return window.addEventListener("keydown", s, !0), window.addEventListener("mousemove", a, !0), () => {
      window.removeEventListener("keydown", s, !0), window.removeEventListener("mousemove", a, !0);
    };
  }, [e]), I(() => {
    const s = (a) => {
      var l, c;
      if (e === 1) {
        const u = (l = a.target) == null ? void 0 : l.closest("[data-testid]");
        a.altKey && a.shiftKey && u && (a.stopImmediatePropagation(), a.preventDefault(), bs((c = n[0]) == null ? void 0 : c.split(": ")[1]), q.success("Test ID copied to clipboard"));
      }
    };
    return window.addEventListener("click", s, !0), () => window.removeEventListener("click", s, !0);
  }, [e, n]), I(() => {
    q.info(/* @__PURE__ */ Ut(Wr, { children: [
      /* @__PURE__ */ xe("h3", { children: "DevTools is ON" }),
      /* @__PURE__ */ xe("br", {}),
      "press [shift + alt + enter] to switch mode"
    ] }));
  }, []), I(() => {
    document.body.classList.toggle(
      "is-testid-dev-mode",
      e === 1
      /* TestId */
    ), document.body.classList.toggle(
      "is-interactive-dev-mode",
      e === 2
      /* Interactive */
    );
  }, [e]), /* @__PURE__ */ Ut("div", { className: on(ft("DevTools")), children: [
    o !== "" && /* @__PURE__ */ xe("div", { className: ft("DevTools__title"), children: o }, e),
    n.length > 0 && /* @__PURE__ */ Ut("div", { className: ft("DevTools__message"), children: [
      n.map((s, a) => /* @__PURE__ */ xe("div", { children: s }, a)),
      i !== "" && /* @__PURE__ */ xe("div", { className: ft("DevTools__command"), children: i })
    ] })
  ] });
}, gt = Math.min, Ze = Math.max, an = Math.round, Zt = Math.floor, He = (e) => ({
  x: e,
  y: e
}), $s = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Fs = {
  start: "end",
  end: "start"
};
function _n(e, t, n) {
  return Ze(e, gt(t, n));
}
function Bt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function tt(e) {
  return e.split("-")[0];
}
function jt(e) {
  return e.split("-")[1];
}
function oo(e) {
  return e === "x" ? "y" : "x";
}
function Jn(e) {
  return e === "y" ? "height" : "width";
}
function mn(e) {
  return ["top", "bottom"].includes(tt(e)) ? "y" : "x";
}
function Gn(e) {
  return oo(mn(e));
}
function Bs(e, t, n) {
  n === void 0 && (n = !1);
  const r = jt(e), o = Gn(e), i = Jn(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = ln(s)), [s, ln(s)];
}
function js(e) {
  const t = ln(e);
  return [kn(e), t, kn(t)];
}
function kn(e) {
  return e.replace(/start|end/g, (t) => Fs[t]);
}
function qs(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function Hs(e, t, n, r) {
  const o = jt(e);
  let i = qs(tt(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(kn)))), i;
}
function ln(e) {
  return e.replace(/left|right|bottom|top/g, (t) => $s[t]);
}
function zs(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function so(e) {
  return typeof e != "number" ? zs(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function cn(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function wr(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = mn(t), s = Gn(t), a = Jn(s), l = tt(t), c = i === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, g = r[a] / 2 - o[a] / 2;
  let y;
  switch (l) {
    case "top":
      y = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      y = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      y = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      y = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      y = {
        x: r.x,
        y: r.y
      };
  }
  switch (jt(t)) {
    case "start":
      y[s] -= g * (n && c ? -1 : 1);
      break;
    case "end":
      y[s] += g * (n && c ? -1 : 1);
      break;
  }
  return y;
}
const Ws = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = wr(c, r, l), g = r, y = {}, f = 0;
  for (let m = 0; m < a.length; m++) {
    const {
      name: h,
      fn: v
    } = a[m], {
      x: b,
      y: w,
      data: S,
      reset: A
    } = await v({
      x: u,
      y: d,
      initialPlacement: r,
      placement: g,
      strategy: o,
      middlewareData: y,
      rects: c,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = b ?? u, d = w ?? d, y = {
      ...y,
      [h]: {
        ...y[h],
        ...S
      }
    }, A && f <= 50 && (f++, typeof A == "object" && (A.placement && (g = A.placement), A.rects && (c = A.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : A.rects), {
      x: u,
      y: d
    } = wr(c, g, l)), m = -1);
  }
  return {
    x: u,
    y: d,
    placement: g,
    strategy: o,
    middlewareData: y
  };
};
async function io(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: g = !1,
    padding: y = 0
  } = Bt(t, e), f = so(y), h = a[g ? d === "floating" ? "reference" : "floating" : d], v = cn(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(h))) == null || n ? h : h.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), b = d === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), S = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, A = cn(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: b,
    offsetParent: w,
    strategy: l
  }) : b);
  return {
    top: (v.top - A.top + f.top) / S.y,
    bottom: (A.bottom - v.bottom + f.bottom) / S.y,
    left: (v.left - A.left + f.left) / S.x,
    right: (A.right - v.right + f.right) / S.x
  };
}
const Vs = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = Bt(e, t) || {};
    if (c == null)
      return {};
    const d = so(u), g = {
      x: n,
      y: r
    }, y = Gn(o), f = Jn(y), m = await s.getDimensions(c), h = y === "y", v = h ? "top" : "left", b = h ? "bottom" : "right", w = h ? "clientHeight" : "clientWidth", S = i.reference[f] + i.reference[y] - g[y] - i.floating[f], A = g[y] - i.reference[y], U = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let R = U ? U[w] : 0;
    (!R || !await (s.isElement == null ? void 0 : s.isElement(U))) && (R = a.floating[w] || i.floating[f]);
    const C = S / 2 - A / 2, N = R / 2 - m[f] / 2 - 1, K = gt(d[v], N), Y = gt(d[b], N), H = K, oe = R - m[f] - Y, F = R / 2 - m[f] / 2 + C, J = _n(H, F, oe), G = !l.arrow && jt(o) != null && F !== J && i.reference[f] / 2 - (F < H ? K : Y) - m[f] / 2 < 0, j = G ? F < H ? F - H : F - oe : 0;
    return {
      [y]: g[y] + j,
      data: {
        [y]: J,
        centerOffset: F - J - j,
        ...G && {
          alignmentOffset: j
        }
      },
      reset: G
    };
  }
}), Ks = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: g,
        fallbackStrategy: y = "bestFit",
        fallbackAxisSideDirection: f = "none",
        flipAlignment: m = !0,
        ...h
      } = Bt(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const v = tt(o), b = tt(a) === a, w = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = g || (b || !m ? [ln(a)] : js(a));
      !g && f !== "none" && S.push(...Hs(a, m, f, w));
      const A = [a, ...S], U = await io(t, h), R = [];
      let C = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && R.push(U[v]), d) {
        const H = Bs(o, s, w);
        R.push(U[H[0]], U[H[1]]);
      }
      if (C = [...C, {
        placement: o,
        overflows: R
      }], !R.every((H) => H <= 0)) {
        var N, K;
        const H = (((N = i.flip) == null ? void 0 : N.index) || 0) + 1, oe = A[H];
        if (oe)
          return {
            data: {
              index: H,
              overflows: C
            },
            reset: {
              placement: oe
            }
          };
        let F = (K = C.filter((J) => J.overflows[0] <= 0).sort((J, G) => J.overflows[1] - G.overflows[1])[0]) == null ? void 0 : K.placement;
        if (!F)
          switch (y) {
            case "bestFit": {
              var Y;
              const J = (Y = C.map((G) => [G.placement, G.overflows.filter((j) => j > 0).reduce((j, ee) => j + ee, 0)]).sort((G, j) => G[1] - j[1])[0]) == null ? void 0 : Y[0];
              J && (F = J);
              break;
            }
            case "initialPlacement":
              F = a;
              break;
          }
        if (o !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
};
async function Js(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = tt(n), a = jt(n), l = mn(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = i && l ? -1 : 1, d = Bt(t, e);
  let {
    mainAxis: g,
    crossAxis: y,
    alignmentAxis: f
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return a && typeof f == "number" && (y = a === "end" ? f * -1 : f), l ? {
    x: y * u,
    y: g * c
  } : {
    x: g * c,
    y: y * u
  };
}
const Gs = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: a
      } = t, l = await Js(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, Xs = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (h) => {
            let {
              x: v,
              y: b
            } = h;
            return {
              x: v,
              y: b
            };
          }
        },
        ...l
      } = Bt(e, t), c = {
        x: n,
        y: r
      }, u = await io(t, l), d = mn(tt(o)), g = oo(d);
      let y = c[g], f = c[d];
      if (i) {
        const h = g === "y" ? "top" : "left", v = g === "y" ? "bottom" : "right", b = y + u[h], w = y - u[v];
        y = _n(b, y, w);
      }
      if (s) {
        const h = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", b = f + u[h], w = f - u[v];
        f = _n(b, f, w);
      }
      const m = a.fn({
        ...t,
        [g]: y,
        [d]: f
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r
        }
      };
    }
  };
};
function wt(e) {
  return ao(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ee(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ke(e) {
  var t;
  return (t = (ao(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ao(e) {
  return e instanceof Node || e instanceof Ee(e).Node;
}
function Ne(e) {
  return e instanceof Element || e instanceof Ee(e).Element;
}
function Ue(e) {
  return e instanceof HTMLElement || e instanceof Ee(e).HTMLElement;
}
function vr(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ee(e).ShadowRoot;
}
function qt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Oe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Qs(e) {
  return ["table", "td", "th"].includes(wt(e));
}
function Xn(e) {
  const t = Qn(), n = Oe(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Ys(e) {
  let t = ze(e);
  for (; Ue(t) && !yt(t); ) {
    if (Xn(t))
      return t;
    t = ze(t);
  }
  return null;
}
function Qn() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function yt(e) {
  return ["html", "body", "#document"].includes(wt(e));
}
function Oe(e) {
  return Ee(e).getComputedStyle(e);
}
function hn(e) {
  return Ne(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ze(e) {
  if (wt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    vr(e) && e.host || // Fallback.
    ke(e)
  );
  return vr(t) ? t.host : t;
}
function lo(e) {
  const t = ze(e);
  return yt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ue(t) && qt(t) ? t : lo(t);
}
function $t(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = lo(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = Ee(o);
  return i ? t.concat(s, s.visualViewport || [], qt(o) ? o : [], s.frameElement && n ? $t(s.frameElement) : []) : t.concat(o, $t(o, [], n));
}
function co(e) {
  const t = Oe(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Ue(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, a = an(n) !== i || an(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function Yn(e) {
  return Ne(e) ? e : e.contextElement;
}
function mt(e) {
  const t = Yn(e);
  if (!Ue(t))
    return He(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = co(t);
  let s = (i ? an(n.width) : n.width) / r, a = (i ? an(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Zs = /* @__PURE__ */ He(0);
function uo(e) {
  const t = Ee(e);
  return !Qn() || !t.visualViewport ? Zs : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ei(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Ee(e) ? !1 : t;
}
function nt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Yn(e);
  let s = He(1);
  t && (r ? Ne(r) && (s = mt(r)) : s = mt(e));
  const a = ei(i, n, r) ? uo(i) : He(0);
  let l = (o.left + a.x) / s.x, c = (o.top + a.y) / s.y, u = o.width / s.x, d = o.height / s.y;
  if (i) {
    const g = Ee(i), y = r && Ne(r) ? Ee(r) : r;
    let f = g, m = f.frameElement;
    for (; m && r && y !== f; ) {
      const h = mt(m), v = m.getBoundingClientRect(), b = Oe(m), w = v.left + (m.clientLeft + parseFloat(b.paddingLeft)) * h.x, S = v.top + (m.clientTop + parseFloat(b.paddingTop)) * h.y;
      l *= h.x, c *= h.y, u *= h.x, d *= h.y, l += w, c += S, f = Ee(m), m = f.frameElement;
    }
  }
  return cn({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
const ti = [":popover-open", ":modal"];
function Zn(e) {
  return ti.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function ni(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = ke(r), a = t ? Zn(t.floating) : !1;
  if (r === s || a && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = He(1);
  const u = He(0), d = Ue(r);
  if ((d || !d && !i) && ((wt(r) !== "body" || qt(s)) && (l = hn(r)), Ue(r))) {
    const g = nt(r);
    c = mt(r), u.x = g.x + r.clientLeft, u.y = g.y + r.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y
  };
}
function ri(e) {
  return Array.from(e.getClientRects());
}
function fo(e) {
  return nt(ke(e)).left + hn(e).scrollLeft;
}
function oi(e) {
  const t = ke(e), n = hn(e), r = e.ownerDocument.body, o = Ze(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Ze(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + fo(e);
  const a = -n.scrollTop;
  return Oe(r).direction === "rtl" && (s += Ze(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
function si(e, t) {
  const n = Ee(e), r = ke(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    const c = Qn();
    (!c || c && t === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function ii(e, t) {
  const n = nt(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Ue(e) ? mt(e) : He(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function br(e, t, n) {
  let r;
  if (t === "viewport")
    r = si(e, n);
  else if (t === "document")
    r = oi(ke(e));
  else if (Ne(t))
    r = ii(t, n);
  else {
    const o = uo(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return cn(r);
}
function po(e, t) {
  const n = ze(e);
  return n === t || !Ne(n) || yt(n) ? !1 : Oe(n).position === "fixed" || po(n, t);
}
function ai(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = $t(e, [], !1).filter((a) => Ne(a) && wt(a) !== "body"), o = null;
  const i = Oe(e).position === "fixed";
  let s = i ? ze(e) : e;
  for (; Ne(s) && !yt(s); ) {
    const a = Oe(s), l = Xn(s);
    !l && a.position === "fixed" && (o = null), (i ? !l && !o : !l && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || qt(s) && !l && po(e, s)) ? r = r.filter((u) => u !== s) : o = a, s = ze(s);
  }
  return t.set(e, r), r;
}
function li(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Zn(t) ? [] : ai(t, this._c) : [].concat(n), r], a = s[0], l = s.reduce((c, u) => {
    const d = br(t, u, o);
    return c.top = Ze(d.top, c.top), c.right = gt(d.right, c.right), c.bottom = gt(d.bottom, c.bottom), c.left = Ze(d.left, c.left), c;
  }, br(t, a, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function ci(e) {
  const {
    width: t,
    height: n
  } = co(e);
  return {
    width: t,
    height: n
  };
}
function ui(e, t, n) {
  const r = Ue(t), o = ke(t), i = n === "fixed", s = nt(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = He(0);
  if (r || !r && !i)
    if ((wt(t) !== "body" || qt(o)) && (a = hn(t)), r) {
      const d = nt(t, !0, i, t);
      l.x = d.x + t.clientLeft, l.y = d.y + t.clientTop;
    } else
      o && (l.x = fo(o));
  const c = s.left + a.scrollLeft - l.x, u = s.top + a.scrollTop - l.y;
  return {
    x: c,
    y: u,
    width: s.width,
    height: s.height
  };
}
function Cn(e) {
  return Oe(e).position === "static";
}
function Er(e, t) {
  return !Ue(e) || Oe(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function mo(e, t) {
  const n = Ee(e);
  if (Zn(e))
    return n;
  if (!Ue(e)) {
    let o = ze(e);
    for (; o && !yt(o); ) {
      if (Ne(o) && !Cn(o))
        return o;
      o = ze(o);
    }
    return n;
  }
  let r = Er(e, t);
  for (; r && Qs(r) && Cn(r); )
    r = Er(r, t);
  return r && yt(r) && Cn(r) && !Xn(r) ? n : r || Ys(e) || n;
}
const di = async function(e) {
  const t = this.getOffsetParent || mo, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: ui(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function fi(e) {
  return Oe(e).direction === "rtl";
}
const pi = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ni,
  getDocumentElement: ke,
  getClippingRect: li,
  getOffsetParent: mo,
  getElementRects: di,
  getClientRects: ri,
  getDimensions: ci,
  getScale: mt,
  isElement: Ne,
  isRTL: fi
};
function mi(e, t) {
  let n = null, r;
  const o = ke(e);
  function i() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), i();
    const {
      left: c,
      top: u,
      width: d,
      height: g
    } = e.getBoundingClientRect();
    if (a || t(), !d || !g)
      return;
    const y = Zt(u), f = Zt(o.clientWidth - (c + d)), m = Zt(o.clientHeight - (u + g)), h = Zt(c), b = {
      rootMargin: -y + "px " + -f + "px " + -m + "px " + -h + "px",
      threshold: Ze(0, gt(1, l)) || 1
    };
    let w = !0;
    function S(A) {
      const U = A[0].intersectionRatio;
      if (U !== l) {
        if (!w)
          return s();
        U ? s(!1, U) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      w = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...b,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, b);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function hi(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Yn(e), u = o || i ? [...c ? $t(c) : [], ...$t(t)] : [];
  u.forEach((v) => {
    o && v.addEventListener("scroll", n, {
      passive: !0
    }), i && v.addEventListener("resize", n);
  });
  const d = c && a ? mi(c, n) : null;
  let g = -1, y = null;
  s && (y = new ResizeObserver((v) => {
    let [b] = v;
    b && b.target === c && y && (y.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var w;
      (w = y) == null || w.observe(t);
    })), n();
  }), c && !l && y.observe(c), y.observe(t));
  let f, m = l ? nt(e) : null;
  l && h();
  function h() {
    const v = nt(e);
    m && (v.x !== m.x || v.y !== m.y || v.width !== m.width || v.height !== m.height) && n(), m = v, f = requestAnimationFrame(h);
  }
  return n(), () => {
    var v;
    u.forEach((b) => {
      o && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), d == null || d(), (v = y) == null || v.disconnect(), y = null, l && cancelAnimationFrame(f);
  };
}
const gi = Gs, yi = Xs, wi = Ks, vi = Vs, Sr = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: pi,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return Ws(e, t, {
    ...o,
    platform: i
  });
};
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const bi = "react-tooltip-core-styles", Ei = "react-tooltip-base-styles", Tr = { core: !1, base: !1 };
function Ar({ css: e, id: t = Ei, type: n = "base", ref: r }) {
  var o, i;
  if (!e || typeof document > "u" || Tr[n] || n === "core" && typeof process < "u" && (!((o = process == null ? void 0 : process.env) === null || o === void 0) && o.REACT_TOOLTIP_DISABLE_CORE_STYLES) || n !== "base" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_BASE_STYLES))
    return;
  n === "core" && (t = bi), r || (r = {});
  const { insertAt: s } = r;
  if (document.getElementById(t))
    return void console.warn(`[react-tooltip] Element with id '${t}' already exists. Call \`removeStyle()\` first`);
  const a = document.head || document.getElementsByTagName("head")[0], l = document.createElement("style");
  l.id = t, l.type = "text/css", s === "top" && a.firstChild ? a.insertBefore(l, a.firstChild) : a.appendChild(l), l.styleSheet ? l.styleSheet.cssText = e : l.appendChild(document.createTextNode(e)), Tr[n] = !0;
}
const Rr = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: n = null, place: r = "top", offset: o = 10, strategy: i = "absolute", middlewares: s = [gi(Number(o)), wi({ fallbackAxisSideDirection: "start" }), yi({ padding: 5 })], border: a }) => {
  if (!e)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  if (t === null)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  const l = s;
  return n ? (l.push(vi({ element: n, padding: 5 })), Sr(e, t, { placement: r, strategy: i, middleware: l }).then(({ x: c, y: u, placement: d, middlewareData: g }) => {
    var y, f;
    const m = { left: `${c}px`, top: `${u}px`, border: a }, { x: h, y: v } = (y = g.arrow) !== null && y !== void 0 ? y : { x: 0, y: 0 }, b = (f = { top: "bottom", right: "left", bottom: "top", left: "right" }[d.split("-")[0]]) !== null && f !== void 0 ? f : "bottom", w = a && { borderBottom: a, borderRight: a };
    let S = 0;
    if (a) {
      const A = `${a}`.match(/(\d+)px/);
      S = A != null && A[1] ? Number(A[1]) : 1;
    }
    return { tooltipStyles: m, tooltipArrowStyles: { left: h != null ? `${h}px` : "", top: v != null ? `${v}px` : "", right: "", bottom: "", ...w, [b]: `-${4 + S}px` }, place: d };
  })) : Sr(e, t, { placement: "bottom", strategy: i, middleware: l }).then(({ x: c, y: u, placement: d }) => ({ tooltipStyles: { left: `${c}px`, top: `${u}px` }, tooltipArrowStyles: {}, place: d }));
}, Cr = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), Dr = (e, t, n) => {
  let r = null;
  const o = function(...i) {
    const s = () => {
      r = null;
    };
    !r && (e.apply(this, i), r = setTimeout(s, t));
  };
  return o.cancel = () => {
    r && (clearTimeout(r), r = null);
  }, o;
}, xr = (e) => e !== null && !Array.isArray(e) && typeof e == "object", Mn = (e, t) => {
  if (e === t)
    return !0;
  if (Array.isArray(e) && Array.isArray(t))
    return e.length === t.length && e.every((o, i) => Mn(o, t[i]));
  if (Array.isArray(e) !== Array.isArray(t))
    return !1;
  if (!xr(e) || !xr(t))
    return e === t;
  const n = Object.keys(e), r = Object.keys(t);
  return n.length === r.length && n.every((o) => Mn(e[o], t[o]));
}, Si = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement))
    return !1;
  const t = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((n) => {
    const r = t.getPropertyValue(n);
    return r === "auto" || r === "scroll";
  });
}, Or = (e) => {
  if (!e)
    return null;
  let t = e.parentElement;
  for (; t; ) {
    if (Si(t))
      return t;
    t = t.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, Ti = typeof window < "u" ? Wn : I, Ai = "DEFAULT_TOOLTIP_ID", Ri = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, Ci = Vr({ getTooltipData: () => Ri });
function ho(e = Ai) {
  return Kr(Ci).getTooltipData(e);
}
var dt = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, Dn = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const Di = ({ forwardRef: e, id: t, className: n, classNameArrow: r, variant: o = "dark", anchorId: i, anchorSelect: s, place: a = "top", offset: l = 10, events: c = ["hover"], openOnClick: u = !1, positionStrategy: d = "absolute", middlewares: g, wrapper: y, delayShow: f = 0, delayHide: m = 0, float: h = !1, hidden: v = !1, noArrow: b = !1, clickable: w = !1, closeOnEsc: S = !1, closeOnScroll: A = !1, closeOnResize: U = !1, openEvents: R, closeEvents: C, globalCloseEvents: N, imperativeModeOnly: K, style: Y, position: H, afterShow: oe, afterHide: F, content: J, contentWrapperRef: G, isOpen: j, defaultIsOpen: ee = !1, setIsOpen: fe, activeAnchor: B, setActiveAnchor: pe, border: ce, opacity: se, arrowColor: ie, role: me = "tooltip" }) => {
  var ye;
  const Q = re(null), Me = re(null), ae = re(null), Te = re(null), We = re(null), [$e, En] = M({ tooltipStyles: {}, tooltipArrowStyles: {}, place: a }), [we, Vt] = M(!1), [Ve, Ke] = M(!1), [X, Et] = M(null), St = re(!1), Tt = re(null), { anchorRefs: At, setActiveAnchor: Kt } = ho(t), ot = re(!1), [Fe, Rt] = M([]), Je = re(!1), st = u || c.includes("click"), Ct = st || (R == null ? void 0 : R.click) || (R == null ? void 0 : R.dblclick) || (R == null ? void 0 : R.mousedown), it = R ? { ...R } : { mouseenter: !0, focus: !0, click: !1, dblclick: !1, mousedown: !1 };
  !R && st && Object.assign(it, { mouseenter: !1, focus: !1, click: !0 });
  const Dt = C ? { ...C } : { mouseleave: !0, blur: !0, click: !1, dblclick: !1, mouseup: !1 };
  !C && st && Object.assign(Dt, { mouseleave: !1, blur: !1 });
  const De = N ? { ...N } : { escape: S || !1, scroll: A || !1, resize: U || !1, clickOutsideAnchor: Ct || !1 };
  K && (Object.assign(it, { mouseenter: !1, focus: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(Dt, { mouseleave: !1, blur: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(De, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), Ti(() => (Je.current = !0, () => {
    Je.current = !1;
  }), []);
  const Z = (T) => {
    Je.current && (T && Ke(!0), setTimeout(() => {
      Je.current && (fe == null || fe(T), j === void 0 && Vt(T));
    }, 10));
  };
  I(() => {
    if (j === void 0)
      return () => null;
    j && Ke(!0);
    const T = setTimeout(() => {
      Vt(j);
    }, 10);
    return () => {
      clearTimeout(T);
    };
  }, [j]), I(() => {
    if (we !== St.current)
      if (We.current && clearTimeout(We.current), St.current = we, we)
        oe == null || oe();
      else {
        const T = ((x) => {
          const O = x.match(/^([\d.]+)(ms|s)$/);
          if (!O)
            return 0;
          const [, ne, le] = O;
          return Number(ne) * (le === "ms" ? 1 : 1e3);
        })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
        We.current = setTimeout(() => {
          Ke(!1), Et(null), F == null || F();
        }, T + 25);
      }
  }, [we]);
  const Jt = (T) => {
    En((x) => Mn(x, T) ? x : T);
  }, xt = (T = f) => {
    ae.current && clearTimeout(ae.current), Ve ? Z(!0) : ae.current = setTimeout(() => {
      Z(!0);
    }, T);
  }, at = (T = m) => {
    Te.current && clearTimeout(Te.current), Te.current = setTimeout(() => {
      ot.current || Z(!1);
    }, T);
  }, Ot = (T) => {
    var x;
    if (!T)
      return;
    const O = (x = T.currentTarget) !== null && x !== void 0 ? x : T.target;
    if (!(O != null && O.isConnected))
      return pe(null), void Kt({ current: null });
    f ? xt() : Z(!0), pe(O), Kt({ current: O }), Te.current && clearTimeout(Te.current);
  }, lt = () => {
    w ? at(m || 100) : m ? at() : Z(!1), ae.current && clearTimeout(ae.current);
  }, ct = ({ x: T, y: x }) => {
    var O;
    const ne = { getBoundingClientRect: () => ({ x: T, y: x, width: 0, height: 0, top: x, left: T, right: T, bottom: x }) };
    Rr({ place: (O = X == null ? void 0 : X.place) !== null && O !== void 0 ? O : a, offset: l, elementReference: ne, tooltipReference: Q.current, tooltipArrowReference: Me.current, strategy: d, middlewares: g, border: ce }).then((le) => {
      Jt(le);
    });
  }, ut = (T) => {
    if (!T)
      return;
    const x = T, O = { x: x.clientX, y: x.clientY };
    ct(O), Tt.current = O;
  }, Lt = (T) => {
    var x;
    if (!we)
      return;
    const O = T.target;
    O.isConnected && (!((x = Q.current) === null || x === void 0) && x.contains(O) || [document.querySelector(`[id='${i}']`), ...Fe].some((ne) => ne == null ? void 0 : ne.contains(O)) || (Z(!1), ae.current && clearTimeout(ae.current)));
  }, Gt = Dr(Ot, 50), te = Dr(lt, 50), Ae = (T) => {
    te.cancel(), Gt(T);
  }, D = () => {
    Gt.cancel(), te();
  }, k = Vn(() => {
    var T, x;
    const O = (T = X == null ? void 0 : X.position) !== null && T !== void 0 ? T : H;
    O ? ct(O) : h ? Tt.current && ct(Tt.current) : B != null && B.isConnected && Rr({ place: (x = X == null ? void 0 : X.place) !== null && x !== void 0 ? x : a, offset: l, elementReference: B, tooltipReference: Q.current, tooltipArrowReference: Me.current, strategy: d, middlewares: g, border: ce }).then((ne) => {
      Je.current && Jt(ne);
    });
  }, [we, B, J, Y, a, X == null ? void 0 : X.place, l, d, H, X == null ? void 0 : X.position, h]);
  I(() => {
    var T, x;
    const O = new Set(At);
    Fe.forEach((z) => {
      O.add({ current: z });
    });
    const ne = document.querySelector(`[id='${i}']`);
    ne && O.add({ current: ne });
    const le = () => {
      Z(!1);
    }, Pe = Or(B), Ie = Or(Q.current);
    De.scroll && (window.addEventListener("scroll", le), Pe == null || Pe.addEventListener("scroll", le), Ie == null || Ie.addEventListener("scroll", le));
    let ue = null;
    De.resize ? window.addEventListener("resize", le) : B && Q.current && (ue = hi(B, Q.current, k, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const Re = (z) => {
      z.key === "Escape" && Z(!1);
    };
    De.escape && window.addEventListener("keydown", Re), De.clickOutsideAnchor && window.addEventListener("click", Lt);
    const W = [], Pt = (z) => {
      we && (z == null ? void 0 : z.target) === B || Ot(z);
    }, Ho = (z) => {
      we && (z == null ? void 0 : z.target) === B && lt();
    }, ir = ["mouseenter", "mouseleave", "focus", "blur"], ar = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(it).forEach(([z, _e]) => {
      _e && (ir.includes(z) ? W.push({ event: z, listener: Ae }) : ar.includes(z) && W.push({ event: z, listener: Pt }));
    }), Object.entries(Dt).forEach(([z, _e]) => {
      _e && (ir.includes(z) ? W.push({ event: z, listener: D }) : ar.includes(z) && W.push({ event: z, listener: Ho }));
    }), h && W.push({ event: "pointermove", listener: ut });
    const lr = () => {
      ot.current = !0;
    }, cr = () => {
      ot.current = !1, lt();
    };
    return w && !Ct && ((T = Q.current) === null || T === void 0 || T.addEventListener("mouseenter", lr), (x = Q.current) === null || x === void 0 || x.addEventListener("mouseleave", cr)), W.forEach(({ event: z, listener: _e }) => {
      O.forEach((Sn) => {
        var It;
        (It = Sn.current) === null || It === void 0 || It.addEventListener(z, _e);
      });
    }), () => {
      var z, _e;
      De.scroll && (window.removeEventListener("scroll", le), Pe == null || Pe.removeEventListener("scroll", le), Ie == null || Ie.removeEventListener("scroll", le)), De.resize ? window.removeEventListener("resize", le) : ue == null || ue(), De.clickOutsideAnchor && window.removeEventListener("click", Lt), De.escape && window.removeEventListener("keydown", Re), w && !Ct && ((z = Q.current) === null || z === void 0 || z.removeEventListener("mouseenter", lr), (_e = Q.current) === null || _e === void 0 || _e.removeEventListener("mouseleave", cr)), W.forEach(({ event: Sn, listener: It }) => {
        O.forEach((zo) => {
          var Tn;
          (Tn = zo.current) === null || Tn === void 0 || Tn.removeEventListener(Sn, It);
        });
      });
    };
  }, [B, k, Ve, At, Fe, R, C, N, st, f, m]), I(() => {
    var T, x;
    let O = (x = (T = X == null ? void 0 : X.anchorSelect) !== null && T !== void 0 ? T : s) !== null && x !== void 0 ? x : "";
    !O && t && (O = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`);
    const ne = new MutationObserver((le) => {
      const Pe = [], Ie = [];
      le.forEach((ue) => {
        if (ue.type === "attributes" && ue.attributeName === "data-tooltip-id" && (ue.target.getAttribute("data-tooltip-id") === t ? Pe.push(ue.target) : ue.oldValue === t && Ie.push(ue.target)), ue.type === "childList") {
          if (B) {
            const Re = [...ue.removedNodes].filter((W) => W.nodeType === 1);
            if (O)
              try {
                Ie.push(...Re.filter((W) => W.matches(O))), Ie.push(...Re.flatMap((W) => [...W.querySelectorAll(O)]));
              } catch {
              }
            Re.some((W) => {
              var Pt;
              return !!(!((Pt = W == null ? void 0 : W.contains) === null || Pt === void 0) && Pt.call(W, B)) && (Ke(!1), Z(!1), pe(null), ae.current && clearTimeout(ae.current), Te.current && clearTimeout(Te.current), !0);
            });
          }
          if (O)
            try {
              const Re = [...ue.addedNodes].filter((W) => W.nodeType === 1);
              Pe.push(...Re.filter((W) => W.matches(O))), Pe.push(...Re.flatMap((W) => [...W.querySelectorAll(O)]));
            } catch {
            }
        }
      }), (Pe.length || Ie.length) && Rt((ue) => [...ue.filter((Re) => !Ie.includes(Re)), ...Pe]);
    });
    return ne.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      ne.disconnect();
    };
  }, [t, s, X == null ? void 0 : X.anchorSelect, B]), I(() => {
    k();
  }, [k]), I(() => {
    if (!(G != null && G.current))
      return () => null;
    const T = new ResizeObserver(() => {
      setTimeout(() => k());
    });
    return T.observe(G.current), () => {
      T.disconnect();
    };
  }, [J, G == null ? void 0 : G.current]), I(() => {
    var T;
    const x = document.querySelector(`[id='${i}']`), O = [...Fe, x];
    B && O.includes(B) || pe((T = Fe[0]) !== null && T !== void 0 ? T : x);
  }, [i, Fe, B]), I(() => (ee && Z(!0), () => {
    ae.current && clearTimeout(ae.current), Te.current && clearTimeout(Te.current);
  }), []), I(() => {
    var T;
    let x = (T = X == null ? void 0 : X.anchorSelect) !== null && T !== void 0 ? T : s;
    if (!x && t && (x = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), x)
      try {
        const O = Array.from(document.querySelectorAll(x));
        Rt(O);
      } catch {
        Rt([]);
      }
  }, [t, s, X == null ? void 0 : X.anchorSelect]), I(() => {
    ae.current && (clearTimeout(ae.current), xt(f));
  }, [f]);
  const ve = (ye = X == null ? void 0 : X.content) !== null && ye !== void 0 ? ye : J, Ge = we && Object.keys($e.tooltipStyles).length > 0;
  return Jo(e, () => ({ open: (T) => {
    if (T != null && T.anchorSelect)
      try {
        document.querySelector(T.anchorSelect);
      } catch {
        return void console.warn(`[react-tooltip] "${T.anchorSelect}" is not a valid CSS selector`);
      }
    Et(T ?? null), T != null && T.delay ? xt(T.delay) : Z(!0);
  }, close: (T) => {
    T != null && T.delay ? at(T.delay) : Z(!1);
  }, activeAnchor: B, place: $e.place, isOpen: !!(Ve && !v && ve && Ge) })), Ve && !v && ve ? $.createElement(y, { id: t, role: me, className: on("react-tooltip", dt.tooltip, Dn.tooltip, Dn[o], n, `react-tooltip__place-${$e.place}`, dt[Ge ? "show" : "closing"], Ge ? "react-tooltip__show" : "react-tooltip__closing", d === "fixed" && dt.fixed, w && dt.clickable), onTransitionEnd: (T) => {
    We.current && clearTimeout(We.current), we || T.propertyName !== "opacity" || (Ke(!1), Et(null), F == null || F());
  }, style: { ...Y, ...$e.tooltipStyles, opacity: se !== void 0 && Ge ? se : void 0 }, ref: Q }, ve, $.createElement(y, { className: on("react-tooltip-arrow", dt.arrow, Dn.arrow, r, b && dt.noArrow), style: { ...$e.tooltipArrowStyles, background: ie ? `linear-gradient(to right bottom, transparent 50%, ${ie} 50%)` : void 0 }, ref: Me })) : null;
}, xi = ({ content: e }) => $.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), Dl = $.forwardRef(({ id: e, anchorId: t, anchorSelect: n, content: r, html: o, render: i, className: s, classNameArrow: a, variant: l = "dark", place: c = "top", offset: u = 10, wrapper: d = "div", children: g = null, events: y = ["hover"], openOnClick: f = !1, positionStrategy: m = "absolute", middlewares: h, delayShow: v = 0, delayHide: b = 0, float: w = !1, hidden: S = !1, noArrow: A = !1, clickable: U = !1, closeOnEsc: R = !1, closeOnScroll: C = !1, closeOnResize: N = !1, openEvents: K, closeEvents: Y, globalCloseEvents: H, imperativeModeOnly: oe = !1, style: F, position: J, isOpen: G, defaultIsOpen: j = !1, disableStyleInjection: ee = !1, border: fe, opacity: B, arrowColor: pe, setIsOpen: ce, afterShow: se, afterHide: ie, role: me = "tooltip" }, ye) => {
  const [Q, Me] = M(r), [ae, Te] = M(o), [We, $e] = M(c), [En, we] = M(l), [Vt, Ve] = M(u), [Ke, X] = M(v), [Et, St] = M(b), [Tt, At] = M(w), [Kt, ot] = M(S), [Fe, Rt] = M(d), [Je, st] = M(y), [Ct, it] = M(m), [Dt, De] = M(null), [Z, Jt] = M(null), xt = re(ee), { anchorRefs: at, activeAnchor: Ot } = ho(e), lt = (te) => te == null ? void 0 : te.getAttributeNames().reduce((Ae, D) => {
    var k;
    return D.startsWith("data-tooltip-") && (Ae[D.replace(/^data-tooltip-/, "")] = (k = te == null ? void 0 : te.getAttribute(D)) !== null && k !== void 0 ? k : null), Ae;
  }, {}), ct = (te) => {
    const Ae = { place: (D) => {
      var k;
      $e((k = D) !== null && k !== void 0 ? k : c);
    }, content: (D) => {
      Me(D ?? r);
    }, html: (D) => {
      Te(D ?? o);
    }, variant: (D) => {
      var k;
      we((k = D) !== null && k !== void 0 ? k : l);
    }, offset: (D) => {
      Ve(D === null ? u : Number(D));
    }, wrapper: (D) => {
      var k;
      Rt((k = D) !== null && k !== void 0 ? k : d);
    }, events: (D) => {
      const k = D == null ? void 0 : D.split(" ");
      st(k ?? y);
    }, "position-strategy": (D) => {
      var k;
      it((k = D) !== null && k !== void 0 ? k : m);
    }, "delay-show": (D) => {
      X(D === null ? v : Number(D));
    }, "delay-hide": (D) => {
      St(D === null ? b : Number(D));
    }, float: (D) => {
      At(D === null ? w : D === "true");
    }, hidden: (D) => {
      ot(D === null ? S : D === "true");
    }, "class-name": (D) => {
      De(D);
    } };
    Object.values(Ae).forEach((D) => D(null)), Object.entries(te).forEach(([D, k]) => {
      var ve;
      (ve = Ae[D]) === null || ve === void 0 || ve.call(Ae, k);
    });
  };
  I(() => {
    Me(r);
  }, [r]), I(() => {
    Te(o);
  }, [o]), I(() => {
    $e(c);
  }, [c]), I(() => {
    we(l);
  }, [l]), I(() => {
    Ve(u);
  }, [u]), I(() => {
    X(v);
  }, [v]), I(() => {
    St(b);
  }, [b]), I(() => {
    At(w);
  }, [w]), I(() => {
    ot(S);
  }, [S]), I(() => {
    it(m);
  }, [m]), I(() => {
    xt.current !== ee && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [ee]), I(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: ee === "core", disableBase: ee } }));
  }, []), I(() => {
    var te;
    const Ae = new Set(at);
    let D = n;
    if (!D && e && (D = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), D)
      try {
        document.querySelectorAll(D).forEach((x) => {
          Ae.add({ current: x });
        });
      } catch {
        console.warn(`[react-tooltip] "${D}" is not a valid CSS selector`);
      }
    const k = document.querySelector(`[id='${t}']`);
    if (k && Ae.add({ current: k }), !Ae.size)
      return () => null;
    const ve = (te = Z ?? k) !== null && te !== void 0 ? te : Ot.current, Ge = new MutationObserver((x) => {
      x.forEach((O) => {
        var ne;
        if (!ve || O.type !== "attributes" || !(!((ne = O.attributeName) === null || ne === void 0) && ne.startsWith("data-tooltip-")))
          return;
        const le = lt(ve);
        ct(le);
      });
    }), T = { attributes: !0, childList: !1, subtree: !1 };
    if (ve) {
      const x = lt(ve);
      ct(x), Ge.observe(ve, T);
    }
    return () => {
      Ge.disconnect();
    };
  }, [at, Ot, Z, t, n]), I(() => {
    F != null && F.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), fe && !Cr("border", `${fe}`) && console.warn(`[react-tooltip] "${fe}" is not a valid \`border\`.`), F != null && F.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), B && !Cr("opacity", `${B}`) && console.warn(`[react-tooltip] "${B}" is not a valid \`opacity\`.`);
  }, []);
  let ut = g;
  const Lt = re(null);
  if (i) {
    const te = i({ content: (Z == null ? void 0 : Z.getAttribute("data-tooltip-content")) || Q || null, activeAnchor: Z });
    ut = te ? $.createElement("div", { ref: Lt, className: "react-tooltip-content-wrapper" }, te) : null;
  } else
    Q && (ut = Q);
  ae && (ut = $.createElement(xi, { content: ae }));
  const Gt = { forwardRef: ye, id: e, anchorId: t, anchorSelect: n, className: on(s, Dt), classNameArrow: a, content: ut, contentWrapperRef: Lt, place: We, variant: En, offset: Vt, wrapper: Fe, events: Je, openOnClick: f, positionStrategy: Ct, middlewares: h, delayShow: Ke, delayHide: Et, float: Tt, hidden: Kt, noArrow: A, clickable: U, closeOnEsc: R, closeOnScroll: C, closeOnResize: N, openEvents: K, closeEvents: Y, globalCloseEvents: H, imperativeModeOnly: oe, style: F, position: J, isOpen: G, defaultIsOpen: j, border: fe, opacity: B, arrowColor: pe, setIsOpen: ce, afterShow: se, afterHide: ie, activeAnchor: Z, setActiveAnchor: (te) => Jt(te), role: me };
  return $.createElement(Di, { ...Gt });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || Ar({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), e.detail.disableBase || Ar({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const Oi = () => /* @__PURE__ */ Ut("div", { className: ft("VersionDisplay"), children: [
  "@datassential/platform-ui-lib ",
  "0.2.7"
] });
function go(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Li } = Object.prototype, { getPrototypeOf: er } = Object, gn = /* @__PURE__ */ ((e) => (t) => {
  const n = Li.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Le = (e) => (e = e.toLowerCase(), (t) => gn(t) === e), yn = (e) => (t) => typeof t === e, { isArray: vt } = Array, Ft = yn("undefined");
function Pi(e) {
  return e !== null && !Ft(e) && e.constructor !== null && !Ft(e.constructor) && Se(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const yo = Le("ArrayBuffer");
function Ii(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && yo(e.buffer), t;
}
const Ni = yn("string"), Se = yn("function"), wo = yn("number"), wn = (e) => e !== null && typeof e == "object", Ui = (e) => e === !0 || e === !1, tn = (e) => {
  if (gn(e) !== "object")
    return !1;
  const t = er(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, _i = Le("Date"), ki = Le("File"), Mi = Le("Blob"), $i = Le("FileList"), Fi = (e) => wn(e) && Se(e.pipe), Bi = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Se(e.append) && ((t = gn(e)) === "formdata" || // detect form-data instance
  t === "object" && Se(e.toString) && e.toString() === "[object FormData]"));
}, ji = Le("URLSearchParams"), [qi, Hi, zi, Wi] = ["ReadableStream", "Request", "Response", "Headers"].map(Le), Vi = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ht(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), vt(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), s = i.length;
    let a;
    for (r = 0; r < s; r++)
      a = i[r], t.call(null, e[a], a, e);
  }
}
function vo(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const Xe = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, bo = (e) => !Ft(e) && e !== Xe;
function $n() {
  const { caseless: e } = bo(this) && this || {}, t = {}, n = (r, o) => {
    const i = e && vo(t, o) || o;
    tn(t[i]) && tn(r) ? t[i] = $n(t[i], r) : tn(r) ? t[i] = $n({}, r) : vt(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && Ht(arguments[r], n);
  return t;
}
const Ki = (e, t, n, { allOwnKeys: r } = {}) => (Ht(t, (o, i) => {
  n && Se(o) ? e[i] = go(o, n) : e[i] = o;
}, { allOwnKeys: r }), e), Ji = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Gi = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Xi = (e, t, n, r) => {
  let o, i, s;
  const a = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      s = o[i], (!r || r(s, e, t)) && !a[s] && (t[s] = e[s], a[s] = !0);
    e = n !== !1 && er(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Qi = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Yi = (e) => {
  if (!e)
    return null;
  if (vt(e))
    return e;
  let t = e.length;
  if (!wo(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Zi = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && er(Uint8Array)), ea = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, ta = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, na = Le("HTMLFormElement"), ra = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), Lr = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), oa = Le("RegExp"), Eo = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Ht(n, (o, i) => {
    let s;
    (s = t(o, i, e)) !== !1 && (r[i] = s || o);
  }), Object.defineProperties(e, r);
}, sa = (e) => {
  Eo(e, (t, n) => {
    if (Se(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Se(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, ia = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return vt(e) ? r(e) : r(String(e).split(t)), n;
}, aa = () => {
}, la = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, xn = "abcdefghijklmnopqrstuvwxyz", Pr = "0123456789", So = {
  DIGIT: Pr,
  ALPHA: xn,
  ALPHA_DIGIT: xn + xn.toUpperCase() + Pr
}, ca = (e = 16, t = So.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function ua(e) {
  return !!(e && Se(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const da = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (wn(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const i = vt(r) ? [] : {};
        return Ht(r, (s, a) => {
          const l = n(s, o + 1);
          !Ft(l) && (i[a] = l);
        }), t[o] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, fa = Le("AsyncFunction"), pa = (e) => e && (wn(e) || Se(e)) && Se(e.then) && Se(e.catch), To = ((e, t) => e ? setImmediate : t ? ((n, r) => (Xe.addEventListener("message", ({ source: o, data: i }) => {
  o === Xe && i === n && r.length && r.shift()();
}, !1), (o) => {
  r.push(o), Xe.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Se(Xe.postMessage)
), ma = typeof queueMicrotask < "u" ? queueMicrotask.bind(Xe) : typeof process < "u" && process.nextTick || To, p = {
  isArray: vt,
  isArrayBuffer: yo,
  isBuffer: Pi,
  isFormData: Bi,
  isArrayBufferView: Ii,
  isString: Ni,
  isNumber: wo,
  isBoolean: Ui,
  isObject: wn,
  isPlainObject: tn,
  isReadableStream: qi,
  isRequest: Hi,
  isResponse: zi,
  isHeaders: Wi,
  isUndefined: Ft,
  isDate: _i,
  isFile: ki,
  isBlob: Mi,
  isRegExp: oa,
  isFunction: Se,
  isStream: Fi,
  isURLSearchParams: ji,
  isTypedArray: Zi,
  isFileList: $i,
  forEach: Ht,
  merge: $n,
  extend: Ki,
  trim: Vi,
  stripBOM: Ji,
  inherits: Gi,
  toFlatObject: Xi,
  kindOf: gn,
  kindOfTest: Le,
  endsWith: Qi,
  toArray: Yi,
  forEachEntry: ea,
  matchAll: ta,
  isHTMLForm: na,
  hasOwnProperty: Lr,
  hasOwnProp: Lr,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Eo,
  freezeMethods: sa,
  toObjectSet: ia,
  toCamelCase: ra,
  noop: aa,
  toFiniteNumber: la,
  findKey: vo,
  global: Xe,
  isContextDefined: bo,
  ALPHABET: So,
  generateString: ca,
  isSpecCompliantForm: ua,
  toJSONObject: da,
  isAsyncFn: fa,
  isThenable: pa,
  setImmediate: To,
  asap: ma
};
function L(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o, this.status = o.status ? o.status : null);
}
p.inherits(L, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: p.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ao = L.prototype, Ro = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Ro[e] = { value: e };
});
Object.defineProperties(L, Ro);
Object.defineProperty(Ao, "isAxiosError", { value: !0 });
L.from = (e, t, n, r, o, i) => {
  const s = Object.create(Ao);
  return p.toFlatObject(e, s, function(l) {
    return l !== Error.prototype;
  }, (a) => a !== "isAxiosError"), L.call(s, e.message, t, n, r, o), s.cause = e, s.name = e.name, i && Object.assign(s, i), s;
};
const ha = null;
function Fn(e) {
  return p.isPlainObject(e) || p.isArray(e);
}
function Co(e) {
  return p.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Ir(e, t, n) {
  return e ? e.concat(t).map(function(o, i) {
    return o = Co(o), !n && i ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function ga(e) {
  return p.isArray(e) && !e.some(Fn);
}
const ya = p.toFlatObject(p, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function vn(e, t, n) {
  if (!p.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = p.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, h) {
    return !p.isUndefined(h[m]);
  });
  const r = n.metaTokens, o = n.visitor || u, i = n.dots, s = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && p.isSpecCompliantForm(t);
  if (!p.isFunction(o))
    throw new TypeError("visitor must be a function");
  function c(f) {
    if (f === null)
      return "";
    if (p.isDate(f))
      return f.toISOString();
    if (!l && p.isBlob(f))
      throw new L("Blob is not supported. Use a Buffer instead.");
    return p.isArrayBuffer(f) || p.isTypedArray(f) ? l && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function u(f, m, h) {
    let v = f;
    if (f && !h && typeof f == "object") {
      if (p.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), f = JSON.stringify(f);
      else if (p.isArray(f) && ga(f) || (p.isFileList(f) || p.endsWith(m, "[]")) && (v = p.toArray(f)))
        return m = Co(m), v.forEach(function(w, S) {
          !(p.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Ir([m], S, i) : s === null ? m : m + "[]",
            c(w)
          );
        }), !1;
    }
    return Fn(f) ? !0 : (t.append(Ir(h, m, i), c(f)), !1);
  }
  const d = [], g = Object.assign(ya, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: Fn
  });
  function y(f, m) {
    if (!p.isUndefined(f)) {
      if (d.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      d.push(f), p.forEach(f, function(v, b) {
        (!(p.isUndefined(v) || v === null) && o.call(
          t,
          v,
          p.isString(b) ? b.trim() : b,
          m,
          g
        )) === !0 && y(v, m ? m.concat(b) : [b]);
      }), d.pop();
    }
  }
  if (!p.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), t;
}
function Nr(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function tr(e, t) {
  this._pairs = [], e && vn(e, this, t);
}
const Do = tr.prototype;
Do.append = function(t, n) {
  this._pairs.push([t, n]);
};
Do.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Nr);
  } : Nr;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function wa(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function xo(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || wa, o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = p.isURLSearchParams(t) ? t.toString() : new tr(t, n).toString(r), i) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Ur {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    p.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const Oo = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, va = typeof URLSearchParams < "u" ? URLSearchParams : tr, ba = typeof FormData < "u" ? FormData : null, Ea = typeof Blob < "u" ? Blob : null, Sa = {
  isBrowser: !0,
  classes: {
    URLSearchParams: va,
    FormData: ba,
    Blob: Ea
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, nr = typeof window < "u" && typeof document < "u", Bn = typeof navigator == "object" && navigator || void 0, Ta = nr && (!Bn || ["ReactNative", "NativeScript", "NS"].indexOf(Bn.product) < 0), Aa = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Ra = nr && window.location.href || "http://localhost", Ca = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: nr,
  hasStandardBrowserEnv: Ta,
  hasStandardBrowserWebWorkerEnv: Aa,
  navigator: Bn,
  origin: Ra
}, Symbol.toStringTag, { value: "Module" })), he = {
  ...Ca,
  ...Sa
};
function Da(e, t) {
  return vn(e, new he.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, i) {
      return he.isNode && p.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function xa(e) {
  return p.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Oa(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let i;
  for (r = 0; r < o; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function Lo(e) {
  function t(n, r, o, i) {
    let s = n[i++];
    if (s === "__proto__")
      return !0;
    const a = Number.isFinite(+s), l = i >= n.length;
    return s = !s && p.isArray(o) ? o.length : s, l ? (p.hasOwnProp(o, s) ? o[s] = [o[s], r] : o[s] = r, !a) : ((!o[s] || !p.isObject(o[s])) && (o[s] = []), t(n, r, o[s], i) && p.isArray(o[s]) && (o[s] = Oa(o[s])), !a);
  }
  if (p.isFormData(e) && p.isFunction(e.entries)) {
    const n = {};
    return p.forEachEntry(e, (r, o) => {
      t(xa(r), o, n, 0);
    }), n;
  }
  return null;
}
function La(e, t, n) {
  if (p.isString(e))
    try {
      return (t || JSON.parse)(e), p.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const zt = {
  transitional: Oo,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, i = p.isObject(t);
    if (i && p.isHTMLForm(t) && (t = new FormData(t)), p.isFormData(t))
      return o ? JSON.stringify(Lo(t)) : t;
    if (p.isArrayBuffer(t) || p.isBuffer(t) || p.isStream(t) || p.isFile(t) || p.isBlob(t) || p.isReadableStream(t))
      return t;
    if (p.isArrayBufferView(t))
      return t.buffer;
    if (p.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Da(t, this.formSerializer).toString();
      if ((a = p.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return vn(
          a ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || o ? (n.setContentType("application/json", !1), La(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || zt.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (p.isResponse(t) || p.isReadableStream(t))
      return t;
    if (t && p.isString(t) && (r && !this.responseType || o)) {
      const s = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (s)
          throw a.name === "SyntaxError" ? L.from(a, L.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: he.classes.FormData,
    Blob: he.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
p.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  zt.headers[e] = {};
});
const Pa = p.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Ia = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(s) {
    o = s.indexOf(":"), n = s.substring(0, o).trim().toLowerCase(), r = s.substring(o + 1).trim(), !(!n || t[n] && Pa[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, _r = Symbol("internals");
function Nt(e) {
  return e && String(e).trim().toLowerCase();
}
function nn(e) {
  return e === !1 || e == null ? e : p.isArray(e) ? e.map(nn) : String(e);
}
function Na(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Ua = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function On(e, t, n, r, o) {
  if (p.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!p.isString(t)) {
    if (p.isString(r))
      return t.indexOf(r) !== -1;
    if (p.isRegExp(r))
      return r.test(t);
  }
}
function _a(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function ka(e, t) {
  const n = p.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, i, s) {
        return this[r].call(this, t, o, i, s);
      },
      configurable: !0
    });
  });
}
class ge {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function i(a, l, c) {
      const u = Nt(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = p.findKey(o, u);
      (!d || o[d] === void 0 || c === !0 || c === void 0 && o[d] !== !1) && (o[d || l] = nn(a));
    }
    const s = (a, l) => p.forEach(a, (c, u) => i(c, u, l));
    if (p.isPlainObject(t) || t instanceof this.constructor)
      s(t, n);
    else if (p.isString(t) && (t = t.trim()) && !Ua(t))
      s(Ia(t), n);
    else if (p.isHeaders(t))
      for (const [a, l] of t.entries())
        i(l, a, r);
    else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Nt(t), t) {
      const r = p.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return Na(o);
        if (p.isFunction(n))
          return n.call(this, o, r);
        if (p.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Nt(t), t) {
      const r = p.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || On(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function i(s) {
      if (s = Nt(s), s) {
        const a = p.findKey(r, s);
        a && (!n || On(r, r[a], a, n)) && (delete r[a], o = !0);
      }
    }
    return p.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || On(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return p.forEach(this, (o, i) => {
      const s = p.findKey(r, i);
      if (s) {
        n[s] = nn(o), delete n[i];
        return;
      }
      const a = t ? _a(i) : String(i).trim();
      a !== i && delete n[i], n[a] = nn(o), r[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return p.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && p.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[_r] = this[_r] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(s) {
      const a = Nt(s);
      r[a] || (ka(o, s), r[a] = !0);
    }
    return p.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
ge.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
p.reduceDescriptors(ge.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
p.freezeMethods(ge);
function Ln(e, t) {
  const n = this || zt, r = t || n, o = ge.from(r.headers);
  let i = r.data;
  return p.forEach(e, function(a) {
    i = a.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function Po(e) {
  return !!(e && e.__CANCEL__);
}
function bt(e, t, n) {
  L.call(this, e ?? "canceled", L.ERR_CANCELED, t, n), this.name = "CanceledError";
}
p.inherits(bt, L, {
  __CANCEL__: !0
});
function Io(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new L(
    "Request failed with status code " + n.status,
    [L.ERR_BAD_REQUEST, L.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Ma(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function $a(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, i = 0, s;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = r[i];
    s || (s = c), n[o] = l, r[o] = c;
    let d = i, g = 0;
    for (; d !== o; )
      g += n[d++], d = d % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), c - s < t)
      return;
    const y = u && c - u;
    return y ? Math.round(g * 1e3 / y) : void 0;
  };
}
function Fa(e, t) {
  let n = 0, r = 1e3 / t, o, i;
  const s = (c, u = Date.now()) => {
    n = u, o = null, i && (clearTimeout(i), i = null), e.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), d = u - n;
    d >= r ? s(c, u) : (o = c, i || (i = setTimeout(() => {
      i = null, s(o);
    }, r - d)));
  }, () => o && s(o)];
}
const un = (e, t, n = 3) => {
  let r = 0;
  const o = $a(50, 250);
  return Fa((i) => {
    const s = i.loaded, a = i.lengthComputable ? i.total : void 0, l = s - r, c = o(l), u = s <= a;
    r = s;
    const d = {
      loaded: s,
      total: a,
      progress: a ? s / a : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && a && u ? (a - s) / c : void 0,
      event: i,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, kr = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Mr = (e) => (...t) => p.asap(() => e(...t)), Ba = he.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = he.navigator && /(msie|trident)/i.test(he.navigator.userAgent), n = document.createElement("a");
    let r;
    function o(i) {
      let s = i;
      return t && (n.setAttribute("href", s), s = n.href), n.setAttribute("href", s), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = o(window.location.href), function(s) {
      const a = p.isString(s) ? o(s) : s;
      return a.protocol === r.protocol && a.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), ja = he.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, o, i) {
      const s = [e + "=" + encodeURIComponent(t)];
      p.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), p.isString(r) && s.push("path=" + r), p.isString(o) && s.push("domain=" + o), i === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function qa(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Ha(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function No(e, t) {
  return e && !qa(t) ? Ha(e, t) : t;
}
const $r = (e) => e instanceof ge ? { ...e } : e;
function rt(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d) {
    return p.isPlainObject(c) && p.isPlainObject(u) ? p.merge.call({ caseless: d }, c, u) : p.isPlainObject(u) ? p.merge({}, u) : p.isArray(u) ? u.slice() : u;
  }
  function o(c, u, d) {
    if (p.isUndefined(u)) {
      if (!p.isUndefined(c))
        return r(void 0, c, d);
    } else
      return r(c, u, d);
  }
  function i(c, u) {
    if (!p.isUndefined(u))
      return r(void 0, u);
  }
  function s(c, u) {
    if (p.isUndefined(u)) {
      if (!p.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, u);
  }
  function a(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: a,
    headers: (c, u) => o($r(c), $r(u), !0)
  };
  return p.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = l[u] || o, g = d(e[u], t[u], u);
    p.isUndefined(g) && d !== a || (n[u] = g);
  }), n;
}
const Uo = (e) => {
  const t = rt({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: i, headers: s, auth: a } = t;
  t.headers = s = ge.from(s), t.url = xo(No(t.baseURL, t.url), e.params, e.paramsSerializer), a && s.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let l;
  if (p.isFormData(n)) {
    if (he.hasStandardBrowserEnv || he.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((l = s.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      s.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (he.hasStandardBrowserEnv && (r && p.isFunction(r) && (r = r(t)), r || r !== !1 && Ba(t.url))) {
    const c = o && i && ja.read(i);
    c && s.set(o, c);
  }
  return t;
}, za = typeof XMLHttpRequest < "u", Wa = za && function(e) {
  return new Promise(function(n, r) {
    const o = Uo(e);
    let i = o.data;
    const s = ge.from(o.headers).normalize();
    let { responseType: a, onUploadProgress: l, onDownloadProgress: c } = o, u, d, g, y, f;
    function m() {
      y && y(), f && f(), o.cancelToken && o.cancelToken.unsubscribe(u), o.signal && o.signal.removeEventListener("abort", u);
    }
    let h = new XMLHttpRequest();
    h.open(o.method.toUpperCase(), o.url, !0), h.timeout = o.timeout;
    function v() {
      if (!h)
        return;
      const w = ge.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), A = {
        data: !a || a === "text" || a === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: w,
        config: e,
        request: h
      };
      Io(function(R) {
        n(R), m();
      }, function(R) {
        r(R), m();
      }, A), h = null;
    }
    "onloadend" in h ? h.onloadend = v : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(v);
    }, h.onabort = function() {
      h && (r(new L("Request aborted", L.ECONNABORTED, e, h)), h = null);
    }, h.onerror = function() {
      r(new L("Network Error", L.ERR_NETWORK, e, h)), h = null;
    }, h.ontimeout = function() {
      let S = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const A = o.transitional || Oo;
      o.timeoutErrorMessage && (S = o.timeoutErrorMessage), r(new L(
        S,
        A.clarifyTimeoutError ? L.ETIMEDOUT : L.ECONNABORTED,
        e,
        h
      )), h = null;
    }, i === void 0 && s.setContentType(null), "setRequestHeader" in h && p.forEach(s.toJSON(), function(S, A) {
      h.setRequestHeader(A, S);
    }), p.isUndefined(o.withCredentials) || (h.withCredentials = !!o.withCredentials), a && a !== "json" && (h.responseType = o.responseType), c && ([g, f] = un(c, !0), h.addEventListener("progress", g)), l && h.upload && ([d, y] = un(l), h.upload.addEventListener("progress", d), h.upload.addEventListener("loadend", y)), (o.cancelToken || o.signal) && (u = (w) => {
      h && (r(!w || w.type ? new bt(null, e, h) : w), h.abort(), h = null);
    }, o.cancelToken && o.cancelToken.subscribe(u), o.signal && (o.signal.aborted ? u() : o.signal.addEventListener("abort", u)));
    const b = Ma(o.url);
    if (b && he.protocols.indexOf(b) === -1) {
      r(new L("Unsupported protocol " + b + ":", L.ERR_BAD_REQUEST, e));
      return;
    }
    h.send(i || null);
  });
}, Va = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), o;
    const i = function(c) {
      if (!o) {
        o = !0, a();
        const u = c instanceof Error ? c : this.reason;
        r.abort(u instanceof L ? u : new bt(u instanceof Error ? u.message : u));
      }
    };
    let s = t && setTimeout(() => {
      s = null, i(new L(`timeout ${t} of ms exceeded`, L.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: l } = r;
    return l.unsubscribe = () => p.asap(a), l;
  }
}, Ka = function* (e, t) {
  let n = e.byteLength;
  if (!t || n < t) {
    yield e;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + t, yield e.slice(r, o), r = o;
}, Ja = async function* (e, t) {
  for await (const n of Ga(e))
    yield* Ka(n, t);
}, Ga = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, Fr = (e, t, n, r) => {
  const o = Ja(e, t);
  let i = 0, s, a = (l) => {
    s || (s = !0, r && r(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await o.next();
        if (c) {
          a(), l.close();
          return;
        }
        let d = u.byteLength;
        if (n) {
          let g = i += d;
          n(g);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw a(c), c;
      }
    },
    cancel(l) {
      return a(l), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, bn = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", _o = bn && typeof ReadableStream == "function", Xa = bn && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), ko = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Qa = _o && ko(() => {
  let e = !1;
  const t = new Request(he.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Br = 64 * 1024, jn = _o && ko(() => p.isReadableStream(new Response("").body)), dn = {
  stream: jn && ((e) => e.body)
};
bn && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !dn[t] && (dn[t] = p.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new L(`Response type '${t}' is not supported`, L.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const Ya = async (e) => {
  if (e == null)
    return 0;
  if (p.isBlob(e))
    return e.size;
  if (p.isSpecCompliantForm(e))
    return (await new Request(he.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (p.isArrayBufferView(e) || p.isArrayBuffer(e))
    return e.byteLength;
  if (p.isURLSearchParams(e) && (e = e + ""), p.isString(e))
    return (await Xa(e)).byteLength;
}, Za = async (e, t) => {
  const n = p.toFiniteNumber(e.getContentLength());
  return n ?? Ya(t);
}, el = bn && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: o,
    cancelToken: i,
    timeout: s,
    onDownloadProgress: a,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: g
  } = Uo(e);
  c = c ? (c + "").toLowerCase() : "text";
  let y = Va([o, i && i.toAbortSignal()], s), f;
  const m = y && y.unsubscribe && (() => {
    y.unsubscribe();
  });
  let h;
  try {
    if (l && Qa && n !== "get" && n !== "head" && (h = await Za(u, r)) !== 0) {
      let A = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), U;
      if (p.isFormData(r) && (U = A.headers.get("content-type")) && u.setContentType(U), A.body) {
        const [R, C] = kr(
          h,
          un(Mr(l))
        );
        r = Fr(A.body, Br, R, C);
      }
    }
    p.isString(d) || (d = d ? "include" : "omit");
    const v = "credentials" in Request.prototype;
    f = new Request(t, {
      ...g,
      signal: y,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: v ? d : void 0
    });
    let b = await fetch(f);
    const w = jn && (c === "stream" || c === "response");
    if (jn && (a || w && m)) {
      const A = {};
      ["status", "statusText", "headers"].forEach((N) => {
        A[N] = b[N];
      });
      const U = p.toFiniteNumber(b.headers.get("content-length")), [R, C] = a && kr(
        U,
        un(Mr(a), !0)
      ) || [];
      b = new Response(
        Fr(b.body, Br, R, () => {
          C && C(), m && m();
        }),
        A
      );
    }
    c = c || "text";
    let S = await dn[p.findKey(dn, c) || "text"](b, e);
    return !w && m && m(), await new Promise((A, U) => {
      Io(A, U, {
        data: S,
        headers: ge.from(b.headers),
        status: b.status,
        statusText: b.statusText,
        config: e,
        request: f
      });
    });
  } catch (v) {
    throw m && m(), v && v.name === "TypeError" && /fetch/i.test(v.message) ? Object.assign(
      new L("Network Error", L.ERR_NETWORK, e, f),
      {
        cause: v.cause || v
      }
    ) : L.from(v, v && v.code, e, f);
  }
}), qn = {
  http: ha,
  xhr: Wa,
  fetch: el
};
p.forEach(qn, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const jr = (e) => `- ${e}`, tl = (e) => p.isFunction(e) || e === null || e === !1, Mo = {
  getAdapter: (e) => {
    e = p.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const o = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let s;
      if (r = n, !tl(n) && (r = qn[(s = String(n)).toLowerCase()], r === void 0))
        throw new L(`Unknown adapter '${s}'`);
      if (r)
        break;
      o[s || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(o).map(
        ([a, l]) => `adapter ${a} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = t ? i.length > 1 ? `since :
` + i.map(jr).join(`
`) : " " + jr(i[0]) : "as no adapter specified";
      throw new L(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: qn
};
function Pn(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new bt(null, e);
}
function qr(e) {
  return Pn(e), e.headers = ge.from(e.headers), e.data = Ln.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Mo.getAdapter(e.adapter || zt.adapter)(e).then(function(r) {
    return Pn(e), r.data = Ln.call(
      e,
      e.transformResponse,
      r
    ), r.headers = ge.from(r.headers), r;
  }, function(r) {
    return Po(r) || (Pn(e), r && r.response && (r.response.data = Ln.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = ge.from(r.response.headers))), Promise.reject(r);
  });
}
const $o = "1.7.7", rr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  rr[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Hr = {};
rr.transitional = function(t, n, r) {
  function o(i, s) {
    return "[Axios v" + $o + "] Transitional option '" + i + "'" + s + (r ? ". " + r : "");
  }
  return (i, s, a) => {
    if (t === !1)
      throw new L(
        o(s, " has been removed" + (n ? " in " + n : "")),
        L.ERR_DEPRECATED
      );
    return n && !Hr[s] && (Hr[s] = !0, console.warn(
      o(
        s,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, s, a) : !0;
  };
};
function nl(e, t, n) {
  if (typeof e != "object")
    throw new L("options must be an object", L.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const i = r[o], s = t[i];
    if (s) {
      const a = e[i], l = a === void 0 || s(a, i, e);
      if (l !== !0)
        throw new L("option " + i + " must be " + l, L.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new L("Unknown option " + i, L.ERR_BAD_OPTION);
  }
}
const Hn = {
  assertOptions: nl,
  validators: rr
}, je = Hn.validators;
class et {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Ur(),
      response: new Ur()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const i = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = rt(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: i } = n;
    r !== void 0 && Hn.assertOptions(r, {
      silentJSONParsing: je.transitional(je.boolean),
      forcedJSONParsing: je.transitional(je.boolean),
      clarifyTimeoutError: je.transitional(je.boolean)
    }, !1), o != null && (p.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : Hn.assertOptions(o, {
      encode: je.function,
      serialize: je.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let s = i && p.merge(
      i.common,
      i[n.method]
    );
    i && p.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (f) => {
        delete i[f];
      }
    ), n.headers = ge.concat(s, i);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (l = l && m.synchronous, a.unshift(m.fulfilled, m.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(m) {
      c.push(m.fulfilled, m.rejected);
    });
    let u, d = 0, g;
    if (!l) {
      const f = [qr.bind(this), void 0];
      for (f.unshift.apply(f, a), f.push.apply(f, c), g = f.length, u = Promise.resolve(n); d < g; )
        u = u.then(f[d++], f[d++]);
      return u;
    }
    g = a.length;
    let y = n;
    for (d = 0; d < g; ) {
      const f = a[d++], m = a[d++];
      try {
        y = f(y);
      } catch (h) {
        m.call(this, h);
        break;
      }
    }
    try {
      u = qr.call(this, y);
    } catch (f) {
      return Promise.reject(f);
    }
    for (d = 0, g = c.length; d < g; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = rt(this.defaults, t);
    const n = No(t.baseURL, t.url);
    return xo(n, t.params, t.paramsSerializer);
  }
}
p.forEach(["delete", "get", "head", "options"], function(t) {
  et.prototype[t] = function(n, r) {
    return this.request(rt(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
p.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, s, a) {
      return this.request(rt(a || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: s
      }));
    };
  }
  et.prototype[t] = n(), et.prototype[t + "Form"] = n(!0);
});
class or {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const s = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(o);
      return s.cancel = function() {
        r.unsubscribe(i);
      }, s;
    }, t(function(i, s, a) {
      r.reason || (r.reason = new bt(i, s, a), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new or(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
function rl(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function ol(e) {
  return p.isObject(e) && e.isAxiosError === !0;
}
const zn = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(zn).forEach(([e, t]) => {
  zn[t] = e;
});
function Fo(e) {
  const t = new et(e), n = go(et.prototype.request, t);
  return p.extend(n, et.prototype, t, { allOwnKeys: !0 }), p.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return Fo(rt(e, o));
  }, n;
}
const V = Fo(zt);
V.Axios = et;
V.CanceledError = bt;
V.CancelToken = or;
V.isCancel = Po;
V.VERSION = $o;
V.toFormData = vn;
V.AxiosError = L;
V.Cancel = V.CanceledError;
V.all = function(t) {
  return Promise.all(t);
};
V.spread = rl;
V.isAxiosError = ol;
V.mergeConfig = rt;
V.AxiosHeaders = ge;
V.formToJSON = (e) => Lo(p.isHTMLForm(e) ? new FormData(e) : e);
V.getAdapter = Mo.getAdapter;
V.HttpStatusCode = zn;
V.default = V;
const sr = {
  withCredentials: !0,
  headers: {
    Accept: "application/json"
  }
}, sl = V.create({
  baseURL: `${Jr}`,
  ...sr
}), il = V.create({
  baseURL: `${Gr}`,
  ...sr
}), al = V.create({
  baseURL: `${Xr}`,
  ...sr
});
function Bo(e) {
  switch (e) {
    case ht.QA:
      return sl;
    case ht.Staging:
      return il;
    default:
      return al;
  }
}
const ll = ({
  initialConfig: e,
  method: t = "GET",
  url: n,
  payload: r,
  lazy: o
}) => {
  const { env: i } = Wt(), s = Bo(i), [a, l] = M(null), [c, u] = M(null), [d, g] = M(""), [y, f] = M(!o), m = re(e), h = re(null), v = o ?? !1, b = () => {
    h.current && h.current.abort();
  }, w = Vn(
    async (S = {}) => {
      var U;
      b(), u(null), h.current = new AbortController(), f(!0), l(null);
      const A = {
        ...m == null ? void 0 : m.current,
        ...S
      };
      try {
        const R = await s.request({
          data: r,
          signal: h.current.signal,
          method: t,
          url: n,
          ...A
        });
        u(R.status), l(R.data), f(!1), g("");
      } catch (R) {
        return V.isAxiosError(R) && (g(R.message), u(((U = R.response) == null ? void 0 : U.status) || null)), Promise.reject(R);
      } finally {
        f(!1);
      }
    },
    [t, r, n]
  );
  return I(() => {
    if (v)
      b();
    else {
      const S = setTimeout(() => {
        w().catch((A) => {
          A.code !== "ERR_CANCELED" && console.error(A);
        });
      }, 50);
      return () => {
        clearTimeout(S);
      };
    }
  }, [w, v]), I(() => () => {
    b();
  }, []), { doFetch: w, data: a, error: d, isLoading: y, cancel: b, httpStatus: c };
};
function cl(e) {
  const [t, n] = M(!1), r = Bo(e), o = rn(
    () => {
      switch (e) {
        case ht.QA:
          return Jr;
        case ht.Staging:
          return Gr;
        default:
          return Xr;
      }
    },
    [e]
  ), i = (a) => a, s = Vn(
    (a) => {
      if (V.isAxiosError(a)) {
        const { status: l } = a.response ?? {};
        l === 401 && (window.location.href = `${o}/userAuth?returnUrl=${window.location.href}`);
      }
      return Promise.reject(a);
    },
    [o]
  );
  return I(() => {
    const a = r.interceptors.response.use(i, s);
    return n(!0), () => r.interceptors.response.eject(a);
  }, [r, s]), t;
}
function zr(e) {
  return ft(`platformUserInfoData_${e}`);
}
function ul() {
  const { env: e } = Wt(), [t, n] = M(new Qe()), r = ll({
    url: "/api/Data/GetUserInfo",
    method: "GET"
  });
  return I(() => {
    const o = localStorage.getItem(zr(e)) ?? "";
    o && n(new Qe({ apiModel: JSON.parse(o) }));
  }, [e]), I(() => {
    !r.isLoading && r.data && (n(new Qe({ apiModel: r.data })), localStorage.setItem(zr(e), JSON.stringify(r.data)));
  }, [r.isLoading, r.data]), {
    isLoading: r.isLoading,
    data: t
  };
}
const jo = () => {
  const { appId: e } = Wt(), t = Zo("enable platform");
  return I(() => {
    document.body.classList.toggle("is-platform-enabled", t);
  }, [t]), I(() => {
    if (e) {
      const n = e;
      return document.body.classList.add(`platform-app-${n}`), () => {
        document.body.classList.remove(`platform-app-${n}`);
      };
    }
  }, [e]), null;
}, xl = Go(jo), qo = Vr({
  userInfo: new Qe(),
  isUserInfoLoaded: !1,
  setUserInfo: () => {
  },
  appId: Ce.Snap,
  additionalUserMenu: [],
  env: ht.Live,
  globalSearch: {
    isOpened: !1,
    setIsOpened: () => {
    },
    query: "",
    setQuery: () => {
    }
  }
}), dl = ({ children: e }) => {
  const { setUserInfo: t } = Wt(), { data: n } = ul();
  return I(() => {
    n && t(n);
  }, [n]), n ? /* @__PURE__ */ xe(Wr, { children: e }) : null;
}, Ol = ({
  children: e,
  env: t = ht.Live,
  appId: n,
  additionalUserMenu: r = [],
  enableDevTools: o
}) => {
  const i = cl(t), [s, a] = M(""), [l, c] = M(!1), [u, d] = M(new Qe()), [g, y] = M(!1);
  return I(() => {
    y(!!u.id);
  }, [u]), i ? /* @__PURE__ */ xe(qo.Provider, { value: {
    userInfo: u,
    setUserInfo: d,
    isUserInfoLoaded: g,
    appId: n,
    additionalUserMenu: r,
    env: t,
    globalSearch: {
      isOpened: l,
      setIsOpened: c,
      query: s,
      setQuery: a
    }
  }, children: /* @__PURE__ */ Ut(dl, { children: [
    /* @__PURE__ */ xe(
      Ns,
      {
        position: "bottom-right",
        style: { transform: `translateY(${Qo(-40)})` },
        autoClose: 3e3,
        hideProgressBar: !0,
        closeOnClick: !0,
        theme: "colored",
        transition: Ps
      }
    ),
    /* @__PURE__ */ xe(jo, {}),
    o && /* @__PURE__ */ xe(Ms, {}),
    e,
    /* @__PURE__ */ xe(Oi, {})
  ] }) }) : null;
};
function Wt() {
  return Kr(qo);
}
export {
  Ms as D,
  Cl as G,
  Dl as H,
  dl as I,
  qo as P,
  Yo as R,
  fr as S,
  Qe as U,
  Oi as V,
  Ol as a,
  Wt as b,
  ll as c,
  Us as d,
  Bo as e,
  cl as f,
  ul as g,
  jo as h,
  xl as i,
  Zo as u
};
